import { bus } from "../main";
export default {
  data() {
    return {
      allKeys: {},
      refreshIndex: -1,
    };
  },
  computed: {
    getAddtextBoxStyle() {
      let style = `height: ${this.endingY - this.startingY
        }px !important; width: ${this.endingX - this.startingX
        }px !important; font-size: 16px !important; font-family: Times New Roman; line-height: 1.2;`;
      return style;
    },
  },
  methods: {
    addFieldsOnDocument() {
      this.fieldsAlertModel = false;
      let dateFormat = /^(\d{1,2})\/(\d{1,2})\/\d{4}$/;
      (Object.keys(this.pdfFormFields) || []).forEach((doc) => {
        (Object.keys(this.pdfFormFields[doc]) || []).forEach((page) => {
          let pageData = this.pdfFormFields[doc][page];
          if (pageData && pageData.fields && pageData.fields.length) {
            let selectedPage = document.getElementById(
              `${pageData.docId}_canvas_${pageData.pageId}`
            );
            let pageHeight = selectedPage.height;
            pageData.fields.forEach((el) => {
              let font = {
                name: "Helvetica",
                size: 16,
                style: 0,
                color: "#000000",
              };
              let isDate =
                el.fieldName && el.fieldName.toLowerCase().includes("date")
                  ? el.fieldName.toLowerCase().includes("date")
                  : false;
              let x = el.rect[0] * this.scale + selectedPage.offsetLeft;
              let y =
                pageHeight - el.rect[3] * this.scale + selectedPage.offsetTop;
              if (el.fieldType == "Tx" && el.rect && !el.readOnly) {
                let fieldType = el.multiLine
                  ? "MULTI_LINE_TEXT"
                  : isDate
                    ? "DATE"
                    : "SINGLE_LINE_TEXT";
                let indx = this.getLastIndexOfElement(fieldType);
                indx = indx + 1;
                let fieldHeight = font.size * 1.5;
                let fieldWidth = 150;

                let sizeOfLast = this.getTheLastSize();
                if (sizeOfLast !== null) {
                  fieldWidth = sizeOfLast.width;
                }
                fieldWidth = (el.rect[2] - el.rect[0]) * this.scale;
                fieldHeight = (el.rect[3] - el.rect[1]) * this.scale;
                if (fieldType == "SINGLE_LINE_TEXT" || fieldType == "DATE") {
                  let value =
                    fieldHeight / 1.5 && fieldHeight / 1.5 < 8
                      ? 8
                      : fieldHeight / 1.5;
                  font.size = Math.round(value);
                }
                let singleLineTextMetaData = {
                  type: fieldType,
                  section: "input",
                  style: "background:#cbe2d8;",
                  index: indx,
                  font: font,
                  label: fieldType + indx,
                  placeholder: `${isDate ? "Select Date" : "Enter Value"}`,
                  filled_by: this.selectedRecipient || "SENDER",
                  required: false,
                  value: isDate
                    ? dateFormat.test(el.fieldValue)
                      ? el.fieldValue
                      : ""
                    : el.fieldValue,
                  files: [],
                  sample_files: [],
                  requiredFiles: 1,
                  file_names: [],
                  options: [],
                  boxWidth: 20,
                  is_use_boxes: false,
                  boxes: [],
                  alignStyles: "left",
                  boxNumber: 0,
                };
                let positionSize = {
                  x: x,
                  y: y,
                  height: fieldHeight,
                  width: fieldWidth,
                };
                let singleLineTextElement = {
                  ...singleLineTextMetaData,
                  ...positionSize,
                };
                this.elements.push(singleLineTextElement);
                this.getFieldsFromElements();
              } else if (el.fieldType == "Btn") {
                let indx = this.getLastIndexOfElement("CHECKBOX");
                indx = indx + 1;
                let check_height = 30;
                let check_width = 30;
                if (this.elements.length) {
                  const citrus = this.elements
                    .slice()
                    .reverse()
                    .findIndex((x) => x["type"] === "CHECKBOX");
                  let count = this.elements.length - 1;
                  let finalIndex = citrus >= 0 ? count - citrus : citrus;
                  if (finalIndex > -1) {
                    check_width = this.elements[finalIndex].width;
                    check_height = this.elements[finalIndex].height;
                  }
                }
                check_width = (el.rect[2] - el.rect[0]) * this.scale;
                check_height = (el.rect[3] - el.rect[1]) * this.scale;
                this.elements.push({
                  type: "CHECKBOX",
                  section: "input",
                  style: "background:#cbe2d8;",
                  height: check_height + 2,
                  width: check_width + 2,
                  x: x - 2,
                  y: y - 3,
                  field_type: "CUSTOM_FIELD",
                  index: indx,
                  label: "Checkbox " + indx,
                  placeholder: "Checkbox " + indx,
                  value:
                    el.fieldValue &&
                      el.fieldValue != undefined &&
                      el.hasAppearance &&
                      el.fieldValue.toLowerCase() != "off"
                      ? // (el.fieldValue.toLowerCase() == "on" ||
                      //   el.fieldValue.toLowerCase() == "yes" ||
                      //   el.fieldValue.toLowerCase().includes("yes") ||
                      //   Number(el.fieldValue))
                      true
                      : false,
                  required: false,
                  filled_by: this.selectedRecipient || "SENDER",
                  files: [],
                  font: font,
                  sample_files: [],
                  requiredFiles: 1,
                  file_names: [],
                  options: [],
                  is_use_cross_mark: false,
                });
                this.getFieldsFromElements();
              } else if (el.fieldType == "Ch") {
                let indx = this.getLastIndexOfElement("SELECT");
                indx = indx + 1;
                let font = {
                  name: "Helvetica",
                  size: 16,
                  style: 0,
                  color: "#000000",
                };

                let fontOfLast = this.getTheLastFont();
                if (fontOfLast !== null) {
                  font = fontOfLast;
                }
                let fieldWidth = (200 * font.size) / 16;
                let fieldHeight = 1.5 * font.size;
                fieldWidth = (el.rect[2] - el.rect[0]) * this.scale;
                fieldHeight = (el.rect[3] - el.rect[1]) * this.scale;
                font.size = fieldHeight / 1.5;
                let options = el.options
                  .filter((e) => e.displayValue && e.displayValue.length)
                  .flatMap((e) => e.displayValue);
                this.elements.push({
                  type: "SELECT",
                  section: "input",
                  style: "background:#cbe2d8;",
                  height: fieldHeight,
                  width: fieldWidth,
                  value:
                    el.fieldValue &&
                      el.fieldValue[0] &&
                      el.fieldValue[0].length > 0
                      ? el.fieldValue[0]
                      : "",
                  options: options,
                  x: x,
                  y: y,
                  font: font,
                  index: indx,
                  label: "Select " + indx,
                  placeholder: "Please select...",
                  required: false,
                  filled_by: this.selectedRecipient || "SENDER",
                  files: [],
                  sample_files: [],
                  requiredFiles: 1,
                  alignStyles: "left",
                  file_names: [],
                  is_use_cross_mark: false,
                });
                this.getFieldsFromElements();
                if (options && !options.length) {
                  let index = this.elements.length - 1;
                  this.addItemDataDialogVisible = true;
                  const choosenElement = JSON.parse(
                    JSON.stringify(this.elements[index])
                  );
                  this.selectedItem = { ...{}, ...choosenElement };
                  this.selectedItemIndex = index;
                }
              } else if (el.fieldType == "Sig") {
                let indx = this.getLastIndexOfElement("SIGNATURE");
                indx = indx + 1;
                let fieldHeight = 36;
                let fieldWidth = 225;
                this.elements.push({
                  type: "SIGNATURE",
                  section: "input",
                  style: "background:#cbe2d8;",
                  label: "Signature",
                  placeholder: "Signature " + indx,
                  height: fieldHeight,
                  field_type: "CUSTOM_FIELD",
                  width: fieldWidth,
                  font: font,
                  required: true,
                  x: x,
                  y: y,
                  index: indx,
                  filled_by: this.selectedRecipient || "SENDER",
                  files: [],
                  sample_files: [],
                  requiredFiles: 1,
                  file_names: [],
                  options: [],
                });
                this.getFieldsFromElements();
              }
            });
          }
        });
      });
    },

    mouseDownOnDocument(e) {
      if ((this.$refs.formBuilder && this.isEarserMode) || this.isDrawLine) {
        let data = this.getXandYOnCanvas(e);
        if (
          this.isEditMode &&
          !this.isEarserSelect &&
          !this.isEarserDraw &&
          !this.isDrawingLine &&
          data.x > -1 &&
          data.y > -1 &&
          !this.isEditingText &&
          data.currentPage &&
          !this.isDrawLineColorChange
        ) {
          this.startingX = data.x + data.currentPage.offsetLeft;
          this.startingY = data.y + data.currentPage.offsetTop;
          if (this.isEarserMode) {
            this.isEarserDraw = true;
          } else if (this.isDrawLine) {
            this.isDrawingLine = true;
          }
        } else {
          console.log("executed", !this.isEarserSelect);
        }
      }
    },
    mouseUpOnDocument(e, isEnd) {
      if ((this.$refs.formBuilder && this.isEarserMode) || this.isDrawLine) {
        let data = this.getXandYOnCanvas(e);
        if (
          this.startingX > -1 &&
          this.startingY > -1 &&
          data.x > -1 &&
          data.y > -1 &&
          data.currentPage &&
          !this.isDrawLineColorChange
        ) {
          if (isEnd && this.endingX > -1 && this.endingY > -1) {
            this.isEarserSelect = true;
          } else if (
            this.isEarserDraw &&
            this.isEditMode &&
            !this.isEarserSelect &&
            !isEnd &&
            !this.isDrawLine
          ) {
            this.endingX = data.x + data.currentPage.offsetLeft;
            this.endingY = data.y + data.currentPage.offsetTop;
            let textBox = document.getElementById("whiteRectangle");
            textBox.style.display = "block";
            textBox.style.background = "#FFFFFF";
            textBox.style.height = this.endingY - this.startingY + "px";
            textBox.style.width = this.endingX - this.startingX + "px";
            textBox.style.top = this.startingY + "px";
            textBox.style.left = this.startingX + "px";
            textBox.style.zIndex = "200";
          } else if (
            this.isDrawLine &&
            this.isEditMode &&
            !this.isEarserSelect &&
            !isEnd &&
            this.isDrawingLine
          ) {
            this.endingX = data.x + data.currentPage.offsetLeft;
            this.endingY = data.y + data.currentPage.offsetTop;
            let textBox = document.getElementById("LineRectangle");
            textBox.style.display = "block";
            textBox.style.background = this.drawLineColor
              ? this.drawLineColor
              : "#000000";
            textBox.style.height = 2 + "px";
            textBox.style.width = this.endingX - this.startingX + "px";
            textBox.style.top = this.startingY + "px";
            textBox.style.left = this.startingX + "px";
            textBox.style.zIndex = "200";
          } else if (
            this.isDrawLine &&
            this.isEditMode &&
            this.isEarserSelect &&
            !isEnd &&
            this.isDrawingLine
          ) {
            this.saveRectangle(true);
          }
        }
      }
    },
    getXandYOnCanvas(e) {
      const domEle = this.$refs.formBuilder?.getBoundingClientRect();
      if (
        domEle.x <= e.pageX &&
        domEle.y <= e.pageY &&
        e.pageX <= domEle.width + domEle.x &&
        e.pageY <= domEle.height
      ) {
        let pageBoundary = this.getPagesBoundaries(e.pageY - domEle.y);
        let docId =
          pageBoundary &&
            pageBoundary.data &&
            Number.isInteger(pageBoundary.data.docId)
            ? pageBoundary.data.docId
            : 0;
        let pageId =
          pageBoundary &&
            pageBoundary.data &&
            Number.isInteger(pageBoundary.data.pageId)
            ? pageBoundary.data.pageId + 1
            : 1;
        let id = docId + "_canvas_" + pageId;
        let currentPage = document.getElementById(id.toString());
        if (currentPage) {
          let xOnPage = e.pageX - domEle.x;
          let yOnPage = e.pageY - domEle.y;
          if (
            xOnPage >= currentPage.offsetLeft &&
            xOnPage <= currentPage.offsetLeft + currentPage.width
          ) {
            return {
              x: xOnPage - currentPage.offsetLeft,
              y: yOnPage - currentPage.offsetTop,
              currentPage: currentPage,
            };
          }
        }
      }
      return {
        x: -1,
        y: -1,
        currentPage: null,
      };
    },
    changeSelectedTextColor() {
      this.isChangeColor = true;
    },
    makeSelectedTextItalic() {
      this.isMakeBold = true;
      if (this.selectedText) {
        if (this.selectedText.style.weight == 2) {
          this.selectedText.style.weight = 0;
        } else if (this.selectedText.style.weight == 3) {
          this.selectedText.style.weight = 1;
        } else if (this.selectedText.style.weight == 1) {
          this.selectedText.style.weight = 3;
        } else {
          this.selectedText.style.weight = 2;
        }
      }
    },
    makeSelectedTextBold() {
      this.isMakeItalic = true;
      if (this.selectedText) {
        if (this.selectedText.style.weight == 1) {
          this.selectedText.style.weight = 0;
        } else if (this.selectedText.style.weight == 3) {
          this.selectedText.style.weight = 2;
        } else if (this.selectedText.style.weight == 2) {
          this.selectedText.style.weight = 3;
        } else {
          this.selectedText.style.weight = 1;
        }
      }
    },
    hideTextEdit() {
      if (
        this.isEditingText &&
        this.selectedText &&
        !this.isMakeItalic &&
        !this.isMakeBold &&
        !this.isChangeColor
      ) {
        let currentPage = document.getElementById(
          this.selectedText.currentPage
        );
        if (currentPage) {
          let textX = this.selectedText.transform[4] * this.scale;
          let textY =
            currentPage.height - this.selectedText.transform[5] * this.scale;
          let x = textX;
          let y = textY - this.selectedText.height * this.scale;
          let width = this.selectedText.width * this.scale;
          let style = this.selectedText.style;
          let height =
            this.selectedText.height * this.scale +
            ((this.selectedText.height * this.scale) / 100) * 25;
          let ctx = currentPage.getContext("2d");
          let pixelData = ctx.getImageData(x - 5, y + 5, 1, 1).data;
          let backgroundColor = style.backgroundColorl
            ? style.backgroundColor
            : `rgb(${pixelData[0]}, ${pixelData[1]}, ${pixelData[2]})`;
          // let backgroundColor = "rgb(255,255,255)";
          ctx.fillStyle = backgroundColor;
          ctx.fillRect(x, y, width, height);
          ctx.fillStyle = style.color ? style.color : "#000000";
          let fontHeight =
            this.selectedText.height * this.scale
              ? this.selectedText.height * this.scale
              : 12;
          let fontWeight = "";
          if (this.selectedText.style.weight) {
            if (this.selectedText.style.weight == 1) {
              fontWeight = "bold";
            } else if (this.selectedText.style.weight == 2) {
              fontWeight = "italic";
            } else if (this.selectedText.style.weight == 3) {
              fontWeight = "italic bold";
            }
          }
          ctx.font = `${fontWeight} ${fontHeight}px ${style.fontFamily}`;
          ctx.fillText(
            this.selectedTextInPdf,
            x,
            y + this.selectedText.height * this.scale
          );
          if (
            this.selectedTextPageIndex > -1 &&
            this.selectedTextDocIndex > -1 &&
            this.allPdfText[this.selectedTextDocIndex] &&
            this.selectedTextIndex > -1 &&
            this.allPdfText[this.selectedTextDocIndex][
              this.selectedTextPageIndex
            ].fields &&
            this.allPdfText[this.selectedTextDocIndex][
              this.selectedTextPageIndex
            ].fields[this.selectedTextIndex]
          ) {
            let obj = this.selectedText;
            if (
              this.selectedTextInPdf &&
              obj.str &&
              this.selectedTextInPdf.length > obj.str.length &&
              obj.width
            ) {
              let differ = this.selectedTextInPdf.length - obj.str.length;
              obj.width += differ * this.selectedTextRation;
            }
            this.allPdfText[this.selectedTextDocIndex][
              this.selectedTextPageIndex
            ].fields[this.selectedTextIndex] = JSON.parse(
              JSON.stringify({
                ...obj,
                ...{ str: this.selectedTextInPdf, style: style },
              })
            );
          }
          let existedChangesIndex = this.pdfEditingChanges.findIndex(
            (e) =>
              e.index == this.selectedTextIndex &&
              e.pageIndex == this.selectedTextPageIndex &&
              e.docIndex == this.selectedTextDocIndex
          );
          if (existedChangesIndex != -1) {
            this.pdfEditingChanges[existedChangesIndex] = {
              item: this.allPdfText[this.selectedTextDocIndex][
                this.selectedTextPageIndex
              ].fields[this.selectedTextIndex],
              index: this.selectedTextIndex,
              pageIndex: this.selectedTextPageIndex,
              docIndex: this.selectedTextDocIndex,
              text: this.selectedTextInPdf,
              backgroundColor: backgroundColor,
            };
          } else {
            this.pdfEditingChanges.push({
              item: this.allPdfText[this.selectedTextDocIndex][
                this.selectedTextPageIndex
              ].fields[this.selectedTextIndex],
              index: this.selectedTextIndex,
              pageIndex: this.selectedTextPageIndex,
              docIndex: this.selectedTextDocIndex,
              text: this.selectedTextInPdf,
              backgroundColor: backgroundColor,
              zindex: this.zindex,
            });
            this.zindex++;
          }
          this.selectedTextPageIndex = -1;
          this.selectedTextDocIndex = -1;
          this.selectedTextIndex = -1;
        }
        let textBox = document.getElementById("textHighlight");
        this.isEditingText = false;
        this.selectedText = {};
        this.selectedTextRation = 1;
        this.selectedTextInPdf = "";
        textBox.style.display = "none";
        this.isMakeItalic = false;
        this.isMakeBold = false;
        this.isChangeColor = false;
      }
    },
    hexToRgb(color) {
      const codes = color.slice(color.indexOf("(") + 1, color.lastIndexOf(")"));
      if (codes) {
        let colors = codes.split(",").map((e) => parseInt(e) / 255);
        return colors;
      } else {
        return [1, 1, 1];
      }
    },
    checkPdfChanges() {
      if (
        (this.pdfEditingChanges && this.pdfEditingChanges.length) ||
        (this.pdfRectangleChanges && this.pdfRectangleChanges.length) ||
        (this.pdfLineChanges && this.pdfLineChanges.length && !this.isEditMode)
      ) {
        this.$confirm(
          "Looks like you have not saved your changes. Do you want to Save your changes?",
          "Warning",
          {
            confirmButtonText: "Save",
            cancelButtonText: "Discard",
          }
        )
          .then(() => {
            this.editPdf();
          })
          .catch(async () => {
            this.isPdfEditing = true;
            this.documentDataLoading = true;
            this.allPdfData = [];
            await this.renderAllDocuments(false);
            this.pdfEditingChanges = [];
            this.pdfRectangleChanges = [];
            this.pdfLineChanges = [];
          });
      }
    },
    updateTextBoxHeight() {
      const element = document.getElementById(`earserTextBox`);
      let textBox = document.getElementById("whiteRectangle");
      let y = 0;
      if (element && element.scrollHeight > this.endingY - this.startingY) {
        y = element.scrollHeight - (this.endingY - this.startingY);
      }
      this.endingY = this.endingY + y * 4;
      textBox.style.height = this.endingY - this.startingY + "px";
    },
    addTextRectangle() {
      this.isAddingText = true;
    },
    addTextOnRectangle(context, text, x, y, maxWidth, lineHeight) {
      let lines = text.split("\n");
      context.fillStyle = "#000000";
      context.font = `${16}px Times New Roman`;
      lines.forEach((newLine) => {
        let words = newLine.split(" ");
        let line = "";
        for (let n = 0; n < words.length; n++) {
          let testLine = line + words[n] + " ";
          let metrics = context.measureText(testLine);
          let testWidth = metrics.width;
          if (testWidth > maxWidth && n > 0) {
            context.fillText(line, x, y);
            line = words[n] + " ";
            y += lineHeight;
          } else {
            line = testLine;
          }
        }
        context.fillText(line, x, y);
        y += lineHeight;
      });
      // context.fillText(line, x, y);
      return y;
    },
    saveRectangle(isEarser = false) {
      let pageBoundary = this.getPagesBoundaries(this.startingY);
      let docId =
        pageBoundary &&
          pageBoundary.data &&
          Number.isInteger(pageBoundary.data.docId)
          ? pageBoundary.data.docId
          : 0;
      let pageId =
        pageBoundary &&
          pageBoundary.data &&
          Number.isInteger(pageBoundary.data.pageId)
          ? pageBoundary.data.pageId + 1
          : 1;
      let id = docId + "_canvas_" + pageId;
      let currentPage = document.getElementById(id.toString());
      let ctx = currentPage.getContext("2d");
      this.startingX = this.startingX - currentPage.offsetLeft;
      this.startingY = this.startingY - currentPage.offsetTop;
      this.endingX = this.endingX - currentPage.offsetLeft;
      this.endingY = this.endingY - currentPage.offsetTop;
      if (isEarser) {
        let aRgbHex = this.drawLineColor.replace("#", "").match(/.{1,2}/g);
        let aRgb = [
          parseInt(aRgbHex[0], 16),
          parseInt(aRgbHex[1], 16),
          parseInt(aRgbHex[2], 16),
        ];
        ctx.beginPath();
        ctx.strokeStyle = this.drawLineColor;
        ctx.moveTo(this.startingX, this.startingY + 1);
        ctx.lineWidth = 2;
        ctx.lineTo(this.endingX, this.startingY + 1);
        ctx.stroke();
        let textBox = document.getElementById("LineRectangle");
        textBox.style.display = "none";
        this.pdfLineChanges.push({
          docId: docId,
          x: this.startingX,
          y: this.startingY,
          urx: this.endingX,
          ury: this.endingY,
          color: aRgb,
          pageIndex: pageId,
          zindex: this.zindex,
        });
        this.zindex++;
        this.startingX = -1;
        this.startingY = -1;
        this.endingX = -1;
        this.endingY = -1;
        // setTimeout(() => {
        this.isEarserDraw = false;
        this.isEarserSelect = false;
        this.addedTextOnRectangle = "";
        this.isAddingText = false;
        this.isDrawingLine = false;
        // }, 500);
      } else {
        this.pdfRectangleChanges.push({
          docId: docId,
          x: this.startingX,
          y: this.startingY,
          width: this.endingX - this.startingX,
          height: this.endingY - this.startingY,
          color: [255, 255, 255],
          pageIndex: pageId,
          zindex: this.zindex,
        });
        this.zindex++;
        ctx.beginPath();
        ctx.fillStyle = "#FFFFFF";
        ctx.rect(
          this.startingX,
          this.startingY,
          this.endingX - this.startingX,
          this.endingY - this.startingY
        );
        ctx.fill();
        if (this.isAddingText && this.addedTextOnRectangle) {
          this.addTextOnRectangle(
            ctx,
            this.addedTextOnRectangle,
            this.startingX,
            this.startingY + 14,
            this.endingX - this.startingX,
            20
          );
          // if(newY > this.endingY){
          //   this.endingY = newY+newY
          // }
          let h = this.endingY - this.startingY;
          this.pdfRectangleTextChanges.push({
            docId: docId,
            x: this.startingX,
            y: this.startingY - 12,
            width: this.endingX - this.startingX,
            height: h + h / 2,
            color: [0, 0, 0],
            pageIndex: pageId,
            text: this.addedTextOnRectangle,
            zindex: this.zindex,
          });
          this.zindex++;
        }
        let textBox = document.getElementById("whiteRectangle");
        textBox.style.display = "none";
        this.startingX = -1;
        this.startingY = -1;
        this.endingX = -1;
        this.endingY = -1;
        // setTimeout(() => {
        this.isEarserDraw = false;
        this.isEarserSelect = false;
        this.addedTextOnRectangle = "";
        this.isAddingText = false;
        this.isDrawingLine = false;
        // }, 500);
      }
    },
    deleteRectangle() {
      let textBox = document.getElementById("whiteRectangle");
      textBox.style.display = "none";
      this.startingX = -1;
      this.startingY = -1;
      this.endingX = -1;
      this.endingY = -1;
      setTimeout(() => {
        this.isEarserDraw = false;
        this.isEarserSelect = false;
        this.addedTextOnRectangle = "";
        this.isAddingText = false;
      }, 500);
    },
    auto_grow(id, tag) {
      if (tag === "address" || tag === "MULTI_LINE_TEXT") {
        const element = document.getElementById(id);
        this.activatedItem.height = element.scrollHeight;
      }
    },
    addCurrency() {
      let indx = this.getLastIndexOfElement("CURRENCY");
      indx = indx + 1;
      // let offset = this.getElementYOffet("singleLineTextEle");

      let font = {
        name: "Helvetica",
        size: 16,
        style: 0,
        color: "#000000",
      };

      let fontOfLast = this.getTheLastFont();
      if (fontOfLast !== null) {
        font = fontOfLast;
      }
      let fieldWidth = 150;
      let fieldHeight = font.size * 1.5;
      let sizeOfLast = this.getTheLastSize();
      if (sizeOfLast !== null) {
        fieldWidth = sizeOfLast.width;
        // fieldHeight = sizeOfLast.height;
      }
      let singleLineTextMetaData = {
        type: "CURRENCY",
        section: "input",
        style: "background:#cbe2d8;",
        index: indx,
        font: font,
        label: "Currency " + indx,
        placeholder: "Enter value",
        filled_by: this.recipientSelection || "SENDER_OR_RECEIVER",
        required: this.recipientSelection ? true : false,
        files: [],
        sample_files: [],
        is_entity_variable: false,
        global_variable_entity_field: "",
        requiredFiles: 1,
        file_names: [],
        list_data: [],
        list_data_selected_value_ref: "",
        options: [],
        alignStyles: "left",
        value: 0,
        validations: {
          currency: "USD",
          locale: "en-US",
          required: false,
          type: "NUMBER",
        },
      };

      let positionSize = {
        x:
          this.mouseX +
          this.$refs.formBuilder.scrollLeft -
          this.$refs.formBuilder.getBoundingClientRect().x -
          this.deltaX,
        y:
          this.mouseY +
          this.$refs.formBuilder.scrollTop -
          this.$refs.formBuilder.getBoundingClientRect().y -
          this.deltaY +
          this.dragItemHeight -
          fieldHeight,
        height: fieldHeight,
        width: fieldWidth,
      };

      let singleLineTextElement = {
        ...singleLineTextMetaData,
        ...positionSize,
      };

      const x =
        this.mouseX +
        this.$refs.formBuilder.scrollLeft -
        this.$refs.formBuilder.getBoundingClientRect().x -
        this.deltaX;

      // if (x > this.pageWidth - this.deltaXOfPageWidth) {
      //   return;
      // }
      const y =
        this.mouseY +
        this.$refs.formBuilder.scrollTop -
        this.$refs.formBuilder.getBoundingClientRect().y -
        this.deltaY +
        this.dragItemHeight -
        fieldHeight;
      let pageBoundary = this.getPagesBoundaries(y);
      if (
        pageBoundary &&
        // pageBoundary.pageOffset &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          // x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
          x >= pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        return;
      }
      if (
        pageBoundary &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        singleLineTextElement.x =
          pageBoundary.pageOffset + pageBoundary.pageWidth - fieldWidth;
      }
      let addFieldToHistory = {
        data: singleLineTextElement,
        action: "add",
        index: this.elements.length,
      };
      this.history.push(addFieldToHistory);

      this.elements.push(singleLineTextElement);
      this.getFieldsFromElements();
    },
    addFormula() {
      let indx = this.getLastIndexOfElement("FORMULA");
      indx = indx + 1;
      // let offset = this.getElementYOffet("dropdownEle");
      let font = {
        name: "Helvetica",
        size: 16,
        style: 0,
        color: "#000000",
      };
      let fontOfLast = this.getTheLastFont();
      if (fontOfLast !== null) {
        font = fontOfLast;
      }
      let fieldWidth = (200 * font.size) / 16;
      let fieldHeight = 1.5 * font.size;

      let formulaMetaData = {
        type: "FORMULA",
        section: "input",
        style: "background:#cbe2d8;",

        value: "",
        files: [],
        list_data: [],
        list_data_selected_value_ref: "",
        sample_files: [],
        selected_fields: [],
        is_entity_variable: false,
        global_variable_entity_field: "",
        formula: "",
        validations: {
          currency: "",
          locale: "en-US",
          required: false,
          type: "NUMBER",
        },
        requiredFiles: 1,
        file_names: [],
        options: [],

        font: font,
        index: indx,
        label: "Formula " + indx,
        placeholder: "Formula",
        required: this.recipientSelection ? true : false,
        filled_by: this.recipientSelection || "SENDER_OR_RECEIVER",
      };
      let positionSize = {
        x:
          this.mouseX +
          this.$refs.formBuilder.scrollLeft -
          this.$refs.formBuilder.getBoundingClientRect().x -
          this.deltaX,
        y:
          this.mouseY +
          this.$refs.formBuilder.scrollTop -
          this.$refs.formBuilder.getBoundingClientRect().y -
          this.deltaY +
          this.dragItemHeight -
          fieldHeight,
        height: fieldHeight,
        width: fieldWidth,
      };
      let formulaFieldElement = {
        ...formulaMetaData,
        ...positionSize,
      };
      const x =
        this.mouseX +
        this.$refs.formBuilder.scrollLeft -
        this.$refs.formBuilder.getBoundingClientRect().x -
        this.deltaX;
      const y =
        this.mouseY +
        this.$refs.formBuilder.scrollTop -
        this.$refs.formBuilder.getBoundingClientRect().y -
        this.deltaY +
        this.dragItemHeight -
        fieldHeight;
      let pageBoundary = this.getPagesBoundaries(y);
      if (
        pageBoundary &&
        // pageBoundary.pageOffset &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          // x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
          x >= pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        return;
      }
      if (
        pageBoundary &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        formulaFieldElement.x =
          pageBoundary.pageOffset + pageBoundary.pageWidth - fieldWidth;
      }

      let addFieldToHistory = {
        data: formulaFieldElement,
        action: "add",
        index: this.elements.length,
      };
      this.history.push(addFieldToHistory);
      this.elements.push(formulaFieldElement);
      let index = this.elements.length - 1;
      this.getFieldsFromElements();
      this.addItemDataDialogVisible = true;
      const choosenElement = JSON.parse(JSON.stringify(this.elements[index]));
      this.selectedItem = { ...{}, ...choosenElement };
      this.selectedItemIndex = index;
    },
    addSingleLineContent(item) {
      let indx = this.getLastIndexOfElement("SINGLE_LINE_CONTENT");
      indx = indx + 1;
      let font = {
        name: "Helvetica",
        size: 14,
        style: 0,
        color: "#000000",
      };
      let fontOfLast = this.getTheLastFont();
      if (fontOfLast !== null) {
        font = fontOfLast;
      }
      let docUsers = this.documentRecipientsList
        ? this.documentRecipientsList
        : this.documentUsers;
      let ccUser = docUsers.find(
        (user) =>
          user.type != "SENDER" &&
          user.user_type === "CC" &&
          this.recipientSelection === user.value
      );
      let fieldWidth = (120 * font.size) / 16;
      let fieldHeight = this.openCk ? 24 : 1.5 * font.size;
      let SingleLineContentMetaData = {
        type: "SINGLE_LINE_CONTENT",
        section: "input",
        style: "background:#cbe2d8;",
        font: font,
        index: indx,
        label: "Single line content " + indx,
        placeholder: "Single line content " + indx,
        required: this.recipientSelection ? true : false,
        filled_by: this.openCk
          ? item.filled_by
          : ccUser && docUsers && docUsers.length <= 2
            ? "SENDER"
            : this.recipientSelection || "SENDER_OR_RECEIVER",
        content: "",
        files: [],
        class: "customFieldsData",
        sample_files: [],
        is_entity_variable: false,
        global_variable_entity_field: "",
        list_data: [],
        list_data_selected_value_ref: "",
        requiredFiles: 1,
        file_names: [],
        options: [],
        alignStyles: "left",
      };

      let positionSize = {
        x: this.openCk
          ? item.x
          : this.mouseX +
          this.$refs.formBuilder.scrollLeft -
          this.$refs.formBuilder.getBoundingClientRect().x -
          this.deltaX,
        y: this.openCk
          ? item.y
          : this.mouseY +
          this.$refs.formBuilder.scrollTop -
          this.$refs.formBuilder.getBoundingClientRect().y -
          this.deltaY +
          this.dragItemHeight -
          fieldHeight,
        height: this.openCk ? item.height : fieldHeight,
        width: this.openCk ? item.width : fieldWidth,
      };
      let SingleLineContentElement = {
        ...SingleLineContentMetaData,
        ...positionSize,
      };

      const x = this.openCk
        ? item.x
        : this.mouseX +
        this.$refs.formBuilder.scrollLeft -
        this.$refs.formBuilder.getBoundingClientRect().x -
        this.deltaX;
      const y = this.openCk
        ? item.y
        : this.mouseY +
        this.$refs.formBuilder.scrollTop -
        this.$refs.formBuilder.getBoundingClientRect().y -
        this.deltaY +
        this.dragItemHeight -
        fieldHeight;

      let pageBoundary = this.openCk ? 1300 : this.getPagesBoundaries(y);
      if (
        pageBoundary &&
        // pageBoundary.pageOffset &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          // x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
          x >= pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        return;
      }
      if (
        pageBoundary &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        SingleLineContentElement.x =
          pageBoundary.pageOffset + pageBoundary.pageWidth - fieldWidth;
      }
      let addFieldToHistory = {
        data: SingleLineContentElement,
        action: "add",
        index: this.elements.length,
      };
      this.history.push(addFieldToHistory);
      this.elements.push(SingleLineContentElement);

      let index = this.elements.length - 1;
      this.getFieldsFromElements();
      this.addItemDataDialogVisible = true;
      const choosenElement = JSON.parse(JSON.stringify(this.elements[index]));
      this.selectedItem = { ...{}, ...choosenElement };
      this.selectedItemIndex = index;
    },
    addHorizontalLine() {
      let indx = this.getLastIndexOfElement("HORIZONTAL_LINE");
      indx = indx + 1;
      let font = {
        name: "Helvetica",
        size: 46,
        style: 0,
        color: "#000000",
      };
      let fieldWidth = 200;
      let fieldHeight = 80;
      let hortizontalLineMetaData = {
        type: "HORIZONTAL_LINE",
        inputType: "HORIZONTAL_LINE",
        input_type: "HORIZONTAL_LINE",
        section: "display",
        label: "Horizontal Line",
        color: "#000000",
        field_type: "CUSTOM_FIELD",
        name: "Horizontal Line",
        content: "<hr>",
        text: "",
        font: font,
        list_data: [],
        list_data_selected_value_ref: "",
        index: indx,
        filled_by: "SENDER",
        alignStyles: "left",
      };
      let positionSize = {
        x:
          this.mouseX +
          this.$refs.formBuilder.scrollLeft -
          this.$refs.formBuilder.getBoundingClientRect().x -
          this.deltaX,
        y:
          this.mouseY +
          this.$refs.formBuilder.scrollTop -
          this.$refs.formBuilder.getBoundingClientRect().y -
          this.deltaY +
          this.dragItemHeight -
          fieldHeight,
        height: fieldHeight,
        width: fieldWidth,
      };
      let horizontalLineFieldElement = {
        ...hortizontalLineMetaData,
        ...positionSize,
      };
      const x =
        this.mouseX +
        this.$refs.formBuilder.scrollLeft -
        this.$refs.formBuilder.getBoundingClientRect().x -
        this.deltaX;
      const y =
        this.mouseY +
        this.$refs.formBuilder.scrollTop -
        this.$refs.formBuilder.getBoundingClientRect().y -
        this.deltaY +
        this.dragItemHeight -
        fieldHeight;
      let pageBoundary = this.getPagesBoundaries(y);
      if (
        pageBoundary &&
        // pageBoundary.pageOffset &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          // x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
          x >= pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        return;
      }
      if (
        pageBoundary &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        horizontalLineFieldElement.x =
          pageBoundary.pageOffset + pageBoundary.pageWidth - fieldWidth;
      }
      let addFieldToHistory = {
        data: horizontalLineFieldElement,
        action: "add",
        index: this.elements.length,
      };
      this.history.push(addFieldToHistory);

      this.elements.push(horizontalLineFieldElement);
      this.getFieldsFromElements();
    },
    async convertToImage(data) {
      const numberString = data.toString();
      const [wholeNumber, decimalPart] = numberString.split(".");
      const wholeNumberDigits = wholeNumber.split("");
      const wordDigits = wholeNumberDigits.map(this.convertDigitToWord);

      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const fontSize = 12;
      const lineHeight = 35;
      const textHeight = lineHeight / 2;
      const canvasWidth =
        wordDigits.length * lineHeight -
        20 +
        (decimalPart ? decimalPart.length * lineHeight : 2 * lineHeight);
      const canvasHeight = 38;
      const commaFontSize = 18;
      canvas.width = canvasWidth;
      canvas.height = canvasHeight;

      ctx.font = `${fontSize}px Arial`;
      ctx.fillStyle = "#747474"; // Set the background color
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = "white"; // Set the text color
      ctx.textAlign = "center";

      ctx.fillStyle = "white"; // Set the text color for commas
      const commaPositions = []; // Store the x-positions of commas

      wordDigits.forEach((text, index) => {
        const digit = wholeNumberDigits[index];
        const textX = index * lineHeight;
        ctx.font = `${fontSize}px Arial`;
        ctx.fillText(digit, textX + lineHeight / 2 + 2, textHeight - 4);
        ctx.fillText(text, textX + lineHeight / 2 + 2, lineHeight - 5);
      });

      const decimalText = decimalPart ? decimalPart.padEnd(2, "0") : "00";
      const decimalTextX = wholeNumberDigits.length * lineHeight + 15;
      const decimalTextY = textHeight;
      const decimalWidthBasedOnLineHeight = lineHeight - 15;
      const decimalWidth = decimalText.length * decimalWidthBasedOnLineHeight; // Width of the decimal part

      // Set a different background color for the decimal part
      ctx.fillStyle = "#D3D3D3"; // Example: Gray background color
      ctx.fillRect(decimalTextX, 0, decimalWidth, canvasHeight);

      // Set the text color for the decimal part
      ctx.fillStyle = "black";

      ctx.font = `bold ${fontSize}px Arial`;
      ctx.fillText(
        decimalText,
        decimalTextX + lineHeight / 2 + 2,
        decimalTextY - 5
      );

      // Reset the background color and text color for the cents text
      ctx.fillStyle = "black"; // Original background color
      ctx.font = `bold 10px Arial`;
      ctx.fillText(
        "cents",
        decimalTextX + lineHeight / 2,
        decimalTextY + textHeight - 12
      );

      for (let i = numberString.length - 1, count = 1; i >= 0; i--, count++) {
        if (count % 3 === 0 && i > 0) {
          wordDigits.splice(i, 0, ",");
          commaPositions.push(i);
        }
      }

      wordDigits.forEach((digit, index) => {
        if (digit === ",") {
          wordDigits[index] = " ";
          commaPositions.forEach((position) => {
            const commaX = position * lineHeight;
            const commaY = textHeight;
            ctx.font = `${commaFontSize}px Arial`;
            ctx.fillStyle = "white";
            ctx.fillText(",", commaX, commaY);
          });
        }
      });
      const imageData = canvas.toDataURL("image/png");
      this.elements.forEach((e) => {
        if (e && e.type === "ZSEAL") {
          e.zseal_image_url = imageData;
        }
      });
    },

    convertDigitToWord(digit) {
      // Convert a single digit into its word equivalent
      const words = [
        "Zero",
        "One",
        "Two",
        "Three",
        "Four",
        "Five",
        "Six",
        "Seven",
        "Eight",
        "Nine",
      ];
      const digitIndex = parseInt(digit, 10);
      if (isNaN(digitIndex)) {
        return " ";
      }
      return words[digitIndex];
    },
    checkCurrency(item, index) {
      if (this.editorFields && this.editorFields.length) {
        if (typeof item.value !== "number") {
          item.value = 0;
          this.editorFields[index] = { ...item };
          this.refreshIndex = index;
          setTimeout(() => {
            this.refreshIndex = -1;
          });
        }
      }
      if (typeof item.value !== "number") {
        item.value = 0;
        this.elements[index] = { ...item };
        this.refreshIndex = index;
        setTimeout(() => {
          this.refreshIndex = -1;
        });
      }
      if (item && item.type == "CURRENCY") {
        // convertToImage
        this.number = item.value;
        this.elements.map(async (e) => {
          if (e && e.type == "ZSEAL") {
            if (!e.value || e.value == " ") {
              e.value = await this.convertToImage(item.value);
            }
          }
        });
      }
      this.$nextTick(() => {
        const textareaElement = this.$refs[`textarea_${index}`];
        if (textareaElement && textareaElement.$el) {
          const textareaRef = textareaElement.$el;
          textareaRef.style.textAlign = item.alignStyles;
        }
      });
    },
    addPrimaryField(ref, field) {
      if (this.recipientSelection) {
        let labelName = this.userFields[field];
        let indx = this.getLastIndexOfElement("PRIMARY_FIELDS", field);
        let font = {
          name: "Helvetica",
          size: 16,
          style: 0,
          color: "#000000",
        };
        let fontOfLast = this.getTheLastFont();
        if (fontOfLast !== null) {
          font = fontOfLast;
        }
        let fieldWidth = 100;
        let fieldHeight = font.size * 1.5;
        let sizeOfLast = this.getTheLastSize();
        if (sizeOfLast !== null) {
          fieldWidth = sizeOfLast.width;
          // fieldHeight = sizeOfLast.height;
        }

        indx = indx + 1;
        let label = labelName + " " + indx;
        let fieldContent = this.getFieldVal(
          field,
          this.recipientSelection,
          field === "address" ? true : false
        )
          ? this.getFieldVal(
            field,
            this.recipientSelection,
            field === "address" ? true : false
          )
          : "";

        let primaryfieldsMetaData = {
          type: "PRIMARY_FIELDS",
          section: "display",
          label: label,
          height: fieldHeight,
          font: font,
          width: fieldWidth,
          field_type: "CUSTOM_FIELD",
          selected_tag: field,
          content: fieldContent,
          selected_user: this.recipientSelection,
          filled_by: this.recipientSelection,
          placeholder: this.getPlaceHolder("PRIMARY_FIELDS", field),
          boxes: [],
          is_use_boxes: false,
          is_entity_variable: false,
          global_variable_entity_field: "",
          index: indx,
          boxWidth: 20,
          boxNumber: 0,
          files: [],
          list_data: [],
          list_data_selected_value_ref: "",
          sample_files: [],
          requiredFiles: 1,
          file_names: [],
          options: [],
          addressInfo: "Company Address",
          alignStyles: "left",
        };
        let positionSize = {
          x:
            this.mouseX +
            this.$refs.formBuilder.scrollLeft -
            this.$refs.formBuilder.getBoundingClientRect().x -
            this.deltaX,
          y:
            this.mouseY +
            this.$refs.formBuilder.scrollTop -
            this.$refs.formBuilder.getBoundingClientRect().y -
            this.deltaY +
            this.dragItemHeight -
            fieldHeight,
        };
        let primaryFieldElement = {
          ...primaryfieldsMetaData,
          ...positionSize,
        };
        if (this.elements.length) {
          const citrus = this.elements
            .slice()
            .reverse()
            .findIndex((x) => x["type"] === "PRIMARY_FIELDS");
          let count = this.elements.length - 1;
          let finalIndex = citrus >= 0 ? count - citrus : citrus;
          if (finalIndex > -1) {
            if (fieldContent.length < 6) {
              fieldWidth = font.size * 3;
            } else if (fieldContent.length < 14) {
              fieldWidth = font.size * 6.5;
            } else {
              fieldWidth = font.size * 12;
            }
          } else {
            if (fieldContent.length > 2 && fieldContent.length <= 5) {
              fieldWidth = 50;
            }
            if (fieldContent.length > 5 && fieldContent.length <= 20) {
              fieldWidth = fieldContent.length * 10 - 5;
            }
            if (fieldContent.length > 20) {
              fieldWidth = fieldContent.length * 12;
            }
          }
        } else {
          if (fieldContent.length > 2 && fieldContent.length <= 5) {
            fieldWidth = 50;
          }
          if (fieldContent.length > 5 && fieldContent.length <= 20) {
            fieldWidth = fieldContent.length * 10;
          }
          if (fieldContent.length > 20) {
            fieldWidth = fieldContent.length * 12;
          }
        }
        if (fieldContent.length < 1) {
          fieldWidth = 130;
        }
        if (field === "address") {
          fieldWidth = (300 * font.size) / 16;
          fieldHeight = 3 * font.size;
        }
        const x =
          this.mouseX +
          this.$refs.formBuilder.scrollLeft -
          this.$refs.formBuilder.getBoundingClientRect().x -
          this.deltaX;
        const y =
          this.mouseY +
          this.$refs.formBuilder.scrollTop -
          this.$refs.formBuilder.getBoundingClientRect().y -
          this.deltaY +
          this.dragItemHeight -
          fieldHeight;
        let pageBoundary = this.getPagesBoundaries(y);
        if (
          pageBoundary &&
          // pageBoundary.pageOffset &&
          pageBoundary.pageWidth &&
          (x < pageBoundary.pageOffset ||
            // x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
            x >= pageBoundary.pageOffset + pageBoundary.pageWidth)
        ) {
          return;
        }
        if (
          pageBoundary &&
          pageBoundary.pageWidth &&
          (x < pageBoundary.pageOffset ||
            x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
        ) {
          primaryFieldElement.x =
            pageBoundary.pageOffset + pageBoundary.pageWidth - fieldWidth;
        }
        // if (x > this.pageWidth - this.deltaXOfPageWidth) {
        //   return;
        // }
        let addFieldToHistory = {
          data: primaryFieldElement,
          action: "add",
          index: this.elements.length,
        };
        this.history.push(addFieldToHistory);
        this.elements.push(primaryFieldElement);
        this.getFieldsFromElements();
      } else {
        this.$message({
          message: "Please Select a Receipent User.",
          type: "warning",
        });
      }
    },
    // duplicateField() {
    //   // if(this.selectedItem && this.selectedItem.type){
    //   let indx = this.getLastIndexOfElement(this.selectedItem.type);
    //   indx = indx + 1;
    //   let font = {
    //     name: "Helvetica",
    //     size: 16,
    //     style: 0,
    //     color: "#000000",
    //   };
    //   let fontOfLast = this.getTheLastFont();
    //   if (fontOfLast !== null) {
    //     font = fontOfLast;
    //   }
    //   let labelData
    //   if (/\d/.test(this.selectedItem.label)) {
    //     labelData = this.selectedItem.label.slice(0, -1);
    //   }
    //   let fieldWidth = 150;
    //   let fieldHeight = font.size * 1.5;
    //   let sizeOfLast = this.getTheLastSize();
    //   let lastYPos = this.getTheLastYPosition()

    //   if (sizeOfLast !== null) {
    //     fieldWidth = sizeOfLast.width;
    //     fieldHeight = sizeOfLast.height;
    //   }
    //   let duplicateField = {
    //     type: this.selectedItem.type,
    //     section: this.selectedItem.section,
    //     style: "background:#cbe2d8;",
    //     index: indx,
    //     font: font,
    //     label: labelData + indx,
    //     placeholder: this.selectedItem.placeholder,
    //     filled_by: this.selectedItem.filled_by,
    //     required: this.recipientSelection ? true : false,
    //     files: [],
    //     sample_files: [],
    //     requiredFiles: 1,
    //     file_names: [],
    //     options: [],
    //   }
    //   let positionSize = {
    //     x:
    //       this.mouseX +
    //       this.$refs.formBuilder.scrollLeft -
    //       this.$refs.formBuilder.getBoundingClientRect().x -
    //       this.deltaX,
    //     y:
    //       this.mouseY +
    //       this.$refs.formBuilder.scrollTop -
    //       this.$refs.formBuilder.getBoundingClientRect().y -
    //       this.deltaY +
    //       this.dragItemHeight -
    //       fieldHeight,
    //     height: fieldHeight,
    //     width: fieldWidth,
    //   };
    //   let singleLineTextElement = {
    //     ...duplicateField,
    //     ...positionSize,
    //   };

    //   const x =
    //     this.mouseX +
    //     this.$refs.formBuilder.scrollLeft -
    //     this.$refs.formBuilder.getBoundingClientRect().x -
    //     this.deltaX;

    //   let y =
    //     this.mouseY +
    //     this.$refs.formBuilder.scrollTop -
    //     this.$refs.formBuilder.getBoundingClientRect().y -
    //     this.deltaY +
    //     this.dragItemHeight -
    //     fieldHeight;

    //   let pageBoundary = this.getPagesBoundaries(y);
    //   if (
    //     pageBoundary &&
    //     // pageBoundary.pageOffset &&
    //     pageBoundary.pageWidth &&
    //     (x < pageBoundary.pageOffset ||
    //       // x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
    //       x >= pageBoundary.pageOffset + pageBoundary.pageWidth)
    //   ) {
    //     return;
    //   }
    //   if (
    //     pageBoundary &&
    //     pageBoundary.pageWidth &&
    //     (x < pageBoundary.pageOffset ||
    //       x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
    //   ) {
    //     singleLineTextElement.x =
    //       pageBoundary.pageOffset + pageBoundary.pageWidth - fieldWidth;
    //   }
    //   singleLineTextElement.y = lastYPos.y
    //   if (pageBoundary &&
    //     pageBoundary.pageWidth &&
    //     (y < pageBoundary.pageOffset ||
    //       y + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageHeight)) {
    //     singleLineTextElement.y = pageBoundary.pageOffset + pageBoundary.pageHeight - fieldHeight
    //   }
    // },

    //     this.elements.push(singleLineTextElement);
    //     this.getFieldsFromElements();
    //  // }
    // },
    addTable() {
      let indx = this.getLastIndexOfElement("DATA_TABLE");
      indx = indx + 1;
      let font = {
        name: "Helvetica",
        size: 16,
        style: 0,
        color: "#000000",
      };
      let headerFont = {
        name: "Helvetica",
        size: 16,
        style: 0,
        color: "#000000",
      };
      let rowFont = {
        name: "Helvetica",
        size: 16,
        style: 0,
        color: "#000000",
      };

      let fieldWidth = (120 * font.size) / 16;
      let fieldHeight = 1.5 * font.size;
      let TimeMetaData = {
        type: "DATA_TABLE",
        section: "input",
        style: "background:#cbe2d8;",
        font: rowFont,
        headerFont: headerFont,
        rowFont: rowFont,
        rowsHeight: 30,
        index: indx,
        label: "Data Table " + indx,
        placeholder: "Select Value",
        required: this.recipientSelection ? true : false,
        filled_by: this.recipientSelection || "SENDER_OR_RECEIVER",
        value: "",
        files: [],
        sample_files: [],
        list_data: [],
        requiredFiles: 1,
        file_names: [],
        options: [],
        table_columns_data: [],
        table_data: [],
        table_rows: 0,
        cols: 0,
        headers: [],
        columnWidth: [],
        data: [],
      };
      let positionSize = {
        x:
          this.mouseX +
          this.$refs.formBuilder.scrollLeft -
          this.$refs.formBuilder.getBoundingClientRect().x -
          this.deltaX,
        y:
          this.mouseY +
          this.$refs.formBuilder.scrollTop -
          this.$refs.formBuilder.getBoundingClientRect().y -
          this.deltaY +
          this.dragItemHeight -
          fieldHeight,
      };
      let TimeElement = {
        ...TimeMetaData,
        ...positionSize,
      };

      const x =
        this.mouseX +
        this.$refs.formBuilder.scrollLeft -
        this.$refs.formBuilder.getBoundingClientRect().x -
        this.deltaX;

      // if (x > this.pageWidth - this.deltaXOfPageWidth) {
      //   return;
      // }

      const y =
        this.mouseY +
        this.$refs.formBuilder.scrollTop -
        this.$refs.formBuilder.getBoundingClientRect().y -
        this.deltaY +
        this.dragItemHeight -
        fieldHeight;
      let pageBoundary = this.getPagesBoundaries(y);
      if (
        pageBoundary &&
        // pageBoundary.pageOffset &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          // x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
          x >= pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        return;
      }
      if (
        pageBoundary &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        TimeElement.x =
          pageBoundary.pageOffset + pageBoundary.pageWidth - fieldWidth;
      }
      let addFieldToHistory = {
        data: TimeElement,
        action: "add",
        index: this.elements.length,
      };
      this.history.push(addFieldToHistory);
      this.elements.push(TimeElement);
      let index = this.elements.length - 1;
      this.addItemDataDialogVisible = true;
      const choosenElement = JSON.parse(JSON.stringify(this.elements[index]));
      this.selectedItem = { ...{}, ...choosenElement };
      this.selectedItemIndex = index;
      this.getFieldsFromElements();
    },
    addCkeditor() {
      let indx = this.getLastIndexOfElement("CKEDITOR");
      indx = indx + 1;
      let font = {
        name: "Helvetica",
        size: 14,
        style: 0,
        color: "#000000",
      };
      let fieldWidth = 900;
      let fieldHeight = 800;
      let cKEDITORMetaData = {
        type: "CKEDITOR",
        section: "input",
        style: "background:#cbe2d8;",
        font: font,
        index: indx,
        label: "ckeditor " + indx,
        placeholder: "ckeditor " + indx,
        required: this.recipientSelection ? true : false,
        filled_by: this.recipientSelection || "SENDER_OR_RECEIVER",
        content: "",
        files: [],
        sample_files: [],
        is_entity_variable: false,
        global_variable_entity_field: "",
        list_data: [],
        list_data_selected_value_ref: "",
        requiredFiles: 1,
        file_names: [],
        editorData: "",
        options: [],
        alignStyles: "left",
      };
      let positionSize = {
        x:
          this.mouseX +
          this.$refs.formBuilder.scrollLeft -
          this.$refs.formBuilder.getBoundingClientRect().x -
          this.deltaX,
        y:
          this.mouseY +
          this.$refs.formBuilder.scrollTop -
          this.$refs.formBuilder.getBoundingClientRect().y -
          this.deltaY +
          this.dragItemHeight -
          fieldHeight,
        height: fieldHeight,
        width: fieldWidth,
      };
      let SingleLineContentElement = {
        ...cKEDITORMetaData,
        ...positionSize,
      };

      const x =
        this.mouseX +
        this.$refs.formBuilder.scrollLeft -
        this.$refs.formBuilder.getBoundingClientRect().x -
        this.deltaX;
      const y =
        this.mouseY +
        this.$refs.formBuilder.scrollTop -
        this.$refs.formBuilder.getBoundingClientRect().y -
        this.deltaY +
        this.dragItemHeight -
        fieldHeight;

      let pageBoundary = this.getPagesBoundaries(y);
      if (
        pageBoundary &&
        // pageBoundary.pageOffset &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          // x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
          x >= pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        return;
      }
      if (
        pageBoundary &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        SingleLineContentElement.x =
          pageBoundary.pageOffset + pageBoundary.pageWidth - fieldWidth;
      }
      let addFieldToHistory = {
        data: SingleLineContentElement,
        action: "add",
        index: this.elements.length,
      };
      this.history.push(addFieldToHistory);
      this.elements.push(SingleLineContentElement);
      this.getFieldsFromElements();
    },
    addZseal() {
      let indx = this.getLastIndexOfElement("ZSEAL");
      indx = indx + 1;
      let font = {
        name: "Helvetica",
        size: 14,
        style: 0,
        color: "#000000",
      };
      let fontOfLast = this.getTheLastFont();
      if (fontOfLast !== null) {
        font = fontOfLast;
      }
      let fieldWidth = (390 * font.size) / 16;
      let fieldHeight = 1.5 * font.size;
      let ZsealMetaData = {
        type: "ZSEAL",
        section: "input",
        style: "background:#cbe2d8;",
        font: font,
        index: indx,
        label: "Zseal " + indx,
        required: this.recipientSelection ? true : false,
        filled_by: this.recipientSelection || "SENDER_OR_RECEIVER",
        value: "",
        arrowsImage:
          "data:image/png;base64,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",
        files: [],
        sample_files: [],
        requiredFiles: 1,
        file_names: [],
        options: [],
        zseal_image_url: "",
      };

      let positionSize = {
        x:
          this.mouseX +
          this.$refs.formBuilder.scrollLeft -
          this.$refs.formBuilder.getBoundingClientRect().x -
          this.deltaX,
        y:
          this.mouseY +
          this.$refs.formBuilder.scrollTop -
          this.$refs.formBuilder.getBoundingClientRect().y -
          this.deltaY +
          this.dragItemHeight -
          fieldHeight,
        height: 30,
        width: fieldWidth,
      };
      let ZsealElement = {
        ...ZsealMetaData,
        ...positionSize,
      };
      if (this.checkElementIsBefore("CURRENCY", this.recipientSelection)) {
        const x =
          this.mouseX +
          this.$refs.formBuilder.scrollLeft -
          this.$refs.formBuilder.getBoundingClientRect().x -
          this.deltaX;

        // if (x > this.pageWidth - this.deltaXOfPageWidth) {
        //   return;
        // }
        const y =
          this.mouseY +
          this.$refs.formBuilder.scrollTop -
          this.$refs.formBuilder.getBoundingClientRect().y -
          this.deltaY +
          this.dragItemHeight -
          fieldHeight;

        let pageBoundary = this.getPagesBoundaries(y);
        if (
          pageBoundary &&
          // pageBoundary.pageOffset &&
          pageBoundary.pageWidth &&
          (x < pageBoundary.pageOffset ||
            // x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
            x >= pageBoundary.pageOffset + pageBoundary.pageWidth)
        ) {
          return;
        }
        if (
          pageBoundary &&
          pageBoundary.pageWidth &&
          (x < pageBoundary.pageOffset ||
            x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
        ) {
          ZsealElement.x =
            pageBoundary.pageOffset + pageBoundary.pageWidth - fieldWidth;
        }
        let addFieldToHistory = {
          data: ZsealElement,
          action: "add",
          index: this.elements.length,
        };
        this.history.push(addFieldToHistory);
        this.elements.push(ZsealElement);
      } else {
        this.$message({
          message:
            "The 'Z-seal' field is dependent on the 'Currency' field. Please include a 'Currency' field.",
          type: "warning",
        });
      }
      this.getFieldsFromElements();
    },
    addSingleLineText(item) {
      let indx = this.getLastIndexOfElement("SINGLE_LINE_TEXT");
      indx = indx + 1;
      // let offset = this.getElementYOffet("singleLineTextEle");

      let font = {
        name: "Helvetica",
        size: 16,
        style: 0,
        color: "#000000",
      };

      let fontOfLast = this.getTheLastFont();
      if (fontOfLast !== null) {
        font = fontOfLast;
      }
      let fieldWidth = 150;
      let fieldHeight = this.openCk ? 24 : font.size * 1.5;
      let sizeOfLast = this.getTheLastSize();
      if (sizeOfLast !== null) {
        fieldWidth = sizeOfLast.width;
        // fieldHeight = sizeOfLast.height;
      }
      let docUsers = this.documentRecipientsList
        ? this.documentRecipientsList
        : this.documentUsers;
      let ccUser = docUsers.find(
        (user) =>
          user.type != "SENDER" &&
          user.user_type === "CC" &&
          this.recipientSelection === user.value
      );
      let singleLineTextMetaData = {
        type: "SINGLE_LINE_TEXT",
        section: "input",
        style: "background:#cbe2d8;",
        index: this.openCk ? "" : indx,
        font: font,
        label: this.openCk ? "Single Line Text" : "Single Line Text " + indx,
        placeholder: "Enter value",
        filled_by: this.openCk
          ? item.filled_by
          : ccUser && docUsers && docUsers.length <= 2
            ? "SENDER"
            : this.recipientSelection || "SENDER_OR_RECEIVER",
        is_entity_variable: false,
        global_variable_entity_field: "",
        required: this.openCk ? false : this.recipientSelection ? true : false,
        files: [],
        sample_files: [],
        class: "customFieldsData",
        requiredFiles: 1,
        file_names: [],
        options: [],
        list_data: [],
        list_data_selected_value_ref: "",
        is_use_boxes: false,
        boxes: [],
        boxNumber: 0,
        boxWidth: 20,
        alignStyles: "left",
      };

      let positionSize = {
        x: this.openCk
          ? item.x
          : this.mouseX +
          this.$refs.formBuilder.scrollLeft -
          this.$refs.formBuilder.getBoundingClientRect().x -
          this.deltaX,
        y: this.openCk
          ? item.y
          : this.mouseY +
          this.$refs.formBuilder.scrollTop -
          this.$refs.formBuilder.getBoundingClientRect().y -
          this.deltaY +
          this.dragItemHeight -
          fieldHeight,
        height: this.openCk ? item.height : fieldHeight,
        width: this.openCk ? item.width : fieldWidth,
      };
      let singleLineTextElement = {
        ...singleLineTextMetaData,
        ...positionSize,
      };

      const x = this.openCk
        ? item.x
        : this.mouseX +
        this.$refs.formBuilder.scrollLeft -
        this.$refs.formBuilder.getBoundingClientRect().x -
        this.deltaX;

      // if (x > this.pageWidth - this.deltaXOfPageWidth) {
      //   return;
      // }
      const y = this.openCk
        ? item.y
        : this.mouseY +
        this.$refs.formBuilder.scrollTop -
        this.$refs.formBuilder.getBoundingClientRect().y -
        this.deltaY +
        this.dragItemHeight -
        fieldHeight;
      let pageBoundary = this.openCk ? 1300 : this.getPagesBoundaries(y);
      if (
        pageBoundary &&
        // pageBoundary.pageOffset &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          // x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
          x >= pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        return;
      }
      if (
        pageBoundary &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        singleLineTextElement.x =
          pageBoundary.pageOffset + pageBoundary.pageWidth - fieldWidth;
      }
      // tharuni start
      let name = this.getTheLastXYPositions();
      let addFieldToHistory = {
        data: singleLineTextElement,
        position: name,
        action: "add",
        index: this.elements.length,
      };

      bus.$emit("startingXYpositions", name);
      this.history.push(addFieldToHistory);

      this.elements.push(singleLineTextElement);
      this.getFieldsFromElements();
    },
    addBoxes() {
      let indx = this.getLastIndexOfElement("BOXES");
      indx = indx + 1;
      // let offset = this.getElementYOffet("singleLineTextEle");

      let font = {
        name: "Helvetica",
        size: 16,
        style: 0,
        color: "#000000",
      };

      let fontOfLast = this.getTheLastFont();
      if (fontOfLast !== null) {
        font = fontOfLast;
      }
      let fieldWidth = 150;
      let fieldHeight = font.size * 1.5;
      let sizeOfLast = this.getTheLastSize();
      if (sizeOfLast !== null) {
        fieldWidth = sizeOfLast.width;
        // fieldHeight = sizeOfLast.height;
      }
      let singleLineTextMetaData = {
        type: "BOXES",
        section: "input",
        style: "background:#cbe2d8;",
        index: indx,
        font: font,
        label: "Boxes " + indx,
        placeholder: "Enter value",
        filled_by: this.recipientSelection || "SENDER_OR_RECEIVER",
        is_entity_variable: false,
        global_variable_entity_field: "",
        required: this.recipientSelection ? true : false,
        files: [],
        sample_files: [],
        requiredFiles: 1,
        file_names: [],
        options: [],
        list_data: [],
        list_data_selected_value_ref: "",
        is_use_boxes: false,
        boxes: [],
        boxWidth: 20,
        boxNumber: 0,
      };

      let positionSize = {
        x:
          this.mouseX +
          this.$refs.formBuilder.scrollLeft -
          this.$refs.formBuilder.getBoundingClientRect().x -
          this.deltaX,
        y:
          this.mouseY +
          this.$refs.formBuilder.scrollTop -
          this.$refs.formBuilder.getBoundingClientRect().y -
          this.deltaY +
          this.dragItemHeight -
          fieldHeight,
        height: fieldHeight,
        width: fieldWidth,
      };
      let singleLineTextElement = {
        ...singleLineTextMetaData,
        ...positionSize,
      };

      const x =
        this.mouseX +
        this.$refs.formBuilder.scrollLeft -
        this.$refs.formBuilder.getBoundingClientRect().x -
        this.deltaX;

      // if (x > this.pageWidth - this.deltaXOfPageWidth) {
      //   return;
      // }
      const y =
        this.mouseY +
        this.$refs.formBuilder.scrollTop -
        this.$refs.formBuilder.getBoundingClientRect().y -
        this.deltaY +
        this.dragItemHeight -
        fieldHeight;
      let pageBoundary = this.getPagesBoundaries(y);
      if (
        pageBoundary &&
        // pageBoundary.pageOffset &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          // x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
          x >= pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        return;
      }
      if (
        pageBoundary &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        singleLineTextElement.x =
          pageBoundary.pageOffset + pageBoundary.pageWidth - fieldWidth;
      }
      // tharuni start
      let name = this.getTheLastXYPositions();
      let addFieldToHistory = {
        data: singleLineTextElement,
        position: name,
        action: "add",
        index: this.elements.length,
      };
      bus.$emit("startingXYpositions", name);
      this.history.push(addFieldToHistory);
      this.elements.push(singleLineTextElement);

      this.getFieldsFromElements();
    },
    // tharuni end
    // createAndDataTotableColumns(itemData){
    //   console.log(itemData)
    //   let data = []
    //   this.selectedItem.table_data.map((item) => {
    //     let rowHeader = {};
    //     this.selectedItem.headers.map((header) => {
    //       rowHeader[header] = item[header] || "";
    //     });
    //     data.push(rowHeader);
    //   });
    //   this.selectedItem.table_data = data;
    //   console.log(this.selectedItem.table_data)
    // },

    // if (itemData.data_table_field_index > -1) {
    //   if (
    //     this.elements[itemData.data_table_field_index]
    //       .table_columns_data &&
    //       this.elements[itemData.data_table_field_index]
    //       .table_columns_data.length
    //   ) {
    //     this.elements[
    //       itemData.data_table_field_index
    //     ].table_columns_data.push(itemData);
    //   } else {
    //     this.elements[
    //       itemData.data_table_field_index
    //     ].table_columns_data = [itemData];
    //   }
    // }

    checkTableFields(dimentions) {
      return this.elements.findIndex((field) => {
        if (
          field.type == "DATA_TABLE" &&
          dimentions.x >= field.x &&
          dimentions.x <= field.x + field.width &&
          dimentions.y >= field.y &&
          dimentions.y <= field.y + field.height
        ) {
          return true;
        }
      });
    },
    addMultilineText() {
      let indx = this.getLastIndexOfElement("MULTI_LINE_TEXT");
      indx = indx + 1;
      // let offset = this.getElementYOffet("multiLineTextEle");
      let font = {
        name: "Helvetica",
        size: 16,
        style: 0,
        color: "#000000",
      };

      let fontOfLast = this.getTheLastFont();
      if (fontOfLast !== null) {
        font = fontOfLast;
      }
      let fieldWidth = (300 * font.size) / 16;
      let fieldHeight = 3 * font.size;

      let MultiLineTextMetaData = {
        type: "MULTI_LINE_TEXT",
        section: "input",
        style: "background:#cbe2d8;",
        font: font,
        files: [],
        sample_files: [],
        requiredFiles: 1,
        file_names: [],
        options: [],
        list_data_selected_value_ref: "",
        list_data: [],
        index: indx,
        label: "Multi Line text " + indx,
        placeholder: "Enter value",
        alignStyles: "left",
        required: this.recipientSelection ? true : false,
        filled_by: this.recipientSelection || "SENDER_OR_RECEIVER",
        is_entity_variable: false,
        global_variable_entity_field: "",
      };
      let positionSize = {
        x:
          this.mouseX +
          this.$refs.formBuilder.scrollLeft -
          this.$refs.formBuilder.getBoundingClientRect().x -
          this.deltaX,
        y:
          this.mouseY +
          this.$refs.formBuilder.scrollTop -
          this.$refs.formBuilder.getBoundingClientRect().y -
          this.deltaY +
          this.dragItemHeight -
          fieldHeight,
        height: fieldHeight,
        width: fieldWidth,
      };
      let multiLineTextElement = {
        ...MultiLineTextMetaData,
        ...positionSize,
      };

      const x =
        this.mouseX +
        this.$refs.formBuilder.scrollLeft -
        this.$refs.formBuilder.getBoundingClientRect().x -
        this.deltaX;

      // if (x > this.pageWidth - this.deltaXOfPageWidth) {
      //   return;
      // }

      const y =
        this.mouseY +
        this.$refs.formBuilder.scrollTop -
        this.$refs.formBuilder.getBoundingClientRect().y -
        this.deltaY +
        this.dragItemHeight -
        fieldHeight;
      let pageBoundary = this.getPagesBoundaries(y);
      if (
        pageBoundary &&
        // pageBoundary.pageOffset &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          // x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
          x >= pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        return;
      }
      if (
        pageBoundary &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        multiLineTextElement.x =
          pageBoundary.pageOffset + pageBoundary.pageWidth - fieldWidth;
      }
      let addFieldToHistory = {
        data: multiLineTextElement,
        action: "add",
        index: this.elements.length,
      };
      this.history.push(addFieldToHistory);

      this.elements.push(multiLineTextElement);

      this.getFieldsFromElements();
    },

    addDropDown() {
      let indx = this.getLastIndexOfElement("SELECT");
      indx = indx + 1;
      // let offset = this.getElementYOffet("dropdownEle");
      let font = {
        name: "Helvetica",
        size: 16,
        style: 0,
        color: "#000000",
      };
      let fontOfLast = this.getTheLastFont();
      if (fontOfLast !== null) {
        font = fontOfLast;
      }
      let fieldWidth = (200 * font.size) / 16;
      let fieldHeight = 1.5 * font.size;
      let dropdownMetaData = {
        type: "SELECT",
        section: "input",
        style: "background:#cbe2d8;",
        value: "",
        files: [],
        sample_files: [],
        requiredFiles: 1,
        file_names: [],
        options: [],
        list_data: [],
        list_data_selected_value_ref: "",
        font: font,
        index: indx,
        label: "Select " + indx,
        alignStyles: "left",
        placeholder: "Please select...",
        required: this.recipientSelection ? true : false,
        filled_by: this.recipientSelection || "SENDER_OR_RECEIVER",
        is_entity_variable: false,
        global_variable_entity_field: "",
      };
      let positionSize = {
        x:
          this.mouseX +
          this.$refs.formBuilder.scrollLeft -
          this.$refs.formBuilder.getBoundingClientRect().x -
          this.deltaX,
        y:
          this.mouseY +
          this.$refs.formBuilder.scrollTop -
          this.$refs.formBuilder.getBoundingClientRect().y -
          this.deltaY +
          this.dragItemHeight -
          fieldHeight,
        height: fieldHeight,
        width: fieldWidth,
      };
      let dropdownElement = {
        ...dropdownMetaData,
        ...positionSize,
      };

      const x =
        this.mouseX +
        this.$refs.formBuilder.scrollLeft -
        this.$refs.formBuilder.getBoundingClientRect().x -
        this.deltaX;
      // if (x > this.pageWidth - this.deltaXOfPageWidth) {
      //   return;
      // }
      const y =
        this.mouseY +
        this.$refs.formBuilder.scrollTop -
        this.$refs.formBuilder.getBoundingClientRect().y -
        this.deltaY +
        this.dragItemHeight -
        fieldHeight;
      let pageBoundary = this.getPagesBoundaries(y);
      if (
        pageBoundary &&
        // pageBoundary.pageOffset &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          // x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
          x >= pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        return;
      }
      if (
        pageBoundary &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        dropdownElement.x =
          pageBoundary.pageOffset + pageBoundary.pageWidth - fieldWidth;
      }

      let addFieldToHistory = {
        data: dropdownElement,
        action: "add",
        index: this.elements.length,
      };
      this.history.push(addFieldToHistory);
      this.elements.push(dropdownElement);
      let index = this.elements.length - 1;
      this.addItemDataDialogVisible = true;
      const choosenElement = JSON.parse(JSON.stringify(this.elements[index]));
      this.selectedItem = { ...{}, ...choosenElement };
      this.selectedItemIndex = index;
      this.getFieldsFromElements();
    },
    addMultiSelect() {
      let indx = this.getLastIndexOfElement("MULTI_SELECT");
      indx = indx + 1;
      // let offset = this.getElementYOffet("multiSlectedEle");
      let font = {
        name: "Helvetica",
        size: 16,
        style: 0,
        color: "#000000",
      };

      let fontOfLast = this.getTheLastFont();
      if (fontOfLast !== null) {
        font = fontOfLast;
      }
      let fieldWidth = (200 * font.size * 1.5) / 16;
      let fieldHeight = 2 * font.size;
      const x =
        this.mouseX +
        this.$refs.formBuilder.scrollLeft -
        this.$refs.formBuilder.getBoundingClientRect().x -
        this.deltaX;
      const y =
        this.mouseY +
        this.$refs.formBuilder.scrollTop -
        this.$refs.formBuilder.getBoundingClientRect().y -
        this.deltaY +
        this.dragItemHeight -
        fieldHeight;

      let multiSelectMetaData = {
        type: "MULTI_SELECT",
        section: "input",
        style: "background:#cbe2d8;",
        value: "",
        files: [],
        sample_files: [],
        requiredFiles: 1,
        file_names: [],
        options: [],
        font: font,
        list_data: [],
        list_data_selected_value_ref: "",
        index: indx,
        min_selection: 0,
        max_selection: 0,
        label: "Multi Select " + indx,
        placeholder: "Please select...",
        alignStyles: "left",
        required: this.recipientSelection ? true : false,
        filled_by: this.recipientSelection || "SENDER_OR_RECEIVER",
        is_entity_variable: false,
        global_variable_entity_field: "",
      };
      let positionSize = {
        x:
          this.mouseX +
          this.$refs.formBuilder.scrollLeft -
          this.$refs.formBuilder.getBoundingClientRect().x -
          this.deltaX,
        y:
          this.mouseY +
          this.$refs.formBuilder.scrollTop -
          this.$refs.formBuilder.getBoundingClientRect().y -
          this.deltaY +
          this.dragItemHeight -
          fieldHeight,
        height: fieldHeight,
        width: fieldWidth,
      };

      let multiSelectElement = {
        ...multiSelectMetaData,
        ...positionSize,
      };

      // if (x > this.pageWidth - this.deltaXOfPageWidth) {
      //   return;
      // }

      let pageBoundary = this.getPagesBoundaries(y);
      if (
        pageBoundary &&
        // pageBoundary.pageOffset &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          // x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
          x >= pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        return;
      }
      if (
        pageBoundary &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        multiSelectElement.x =
          pageBoundary.pageOffset + pageBoundary.pageWidth - fieldWidth;
      }

      let addFieldToHistory = {
        data: multiSelectElement,
        action: "add",
        index: this.elements.length,
      };
      this.history.push(addFieldToHistory);
      this.elements.push(multiSelectElement);
      let index = this.elements.length - 1;
      this.addItemDataDialogVisible = true;
      const choosenElement = JSON.parse(JSON.stringify(this.elements[index]));
      this.selectedItem = { ...{}, ...choosenElement };
      this.selectedItemIndex = index;
      this.getFieldsFromElements();
    },
    addCheckbox() {
      let indx = this.getLastIndexOfElement("CHECKBOX");
      indx = indx + 1;
      // let offset = this.getElementYOffet("checkboxEle");
      let check_height = 30;
      let check_width = 30;

      let checkBoxMetaData = {
        type: "CHECKBOX",
        section: "input",
        style: "background:#cbe2d8;",

        font: {
          name: "Helvetica",
          size: 16,
          style: 0,
          color: "#000000",
        },

        field_type: "CUSTOM_FIELD",
        index: indx,
        label: "Checkbox " + indx,
        placeholder: "Checkbox " + indx,
        required: false,
        filled_by: this.recipientSelection || "SENDER_OR_RECEIVER",
        is_entity_variable: false,
        global_variable_entity_field: "",
        files: [],
        sample_files: [],
        requiredFiles: 1,
        list_data: [],
        list_data_selected_value_ref: "",
        file_names: [],
        options: [],
        group_key: "",
        is_show_label: false,
        is_use_cross_mark: false,
      };
      let positionSize = {
        x:
          this.mouseX +
          this.$refs.formBuilder.scrollLeft -
          this.$refs.formBuilder.getBoundingClientRect().x -
          this.deltaX,
        y:
          this.mouseY +
          this.$refs.formBuilder.scrollTop -
          this.$refs.formBuilder.getBoundingClientRect().y -
          this.deltaY +
          this.dragItemHeight -
          check_height,
        height: check_height,
        width: check_width,
      };
      let checkBoxElement = {
        ...checkBoxMetaData,
        ...positionSize,
      };
      if (this.elements.length) {
        const citrus = this.elements
          .slice()
          .reverse()
          .findIndex((x) => x["type"] === "CHECKBOX");
        let count = this.elements.length - 1;
        let finalIndex = citrus >= 0 ? count - citrus : citrus;
        if (finalIndex > -1) {
          check_width = this.elements[finalIndex].width;
          check_height = this.elements[finalIndex].height;
        }
      }

      const x =
        this.mouseX +
        this.$refs.formBuilder.scrollLeft -
        this.$refs.formBuilder.getBoundingClientRect().x -
        this.deltaX;

      const y =
        this.mouseY +
        this.$refs.formBuilder.scrollTop -
        this.$refs.formBuilder.getBoundingClientRect().y -
        this.deltaY +
        this.dragItemHeight -
        check_height;
      let pageBoundary = this.getPagesBoundaries(y);
      if (
        pageBoundary &&
        // pageBoundary.pageOffset &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          // x + check_width > pageBoundary.pageOffset + pageBoundary.pageWidth)
          x >= pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        return;
      }
      if (
        pageBoundary &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          x + check_width > pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        checkBoxElement.x =
          pageBoundary.pageOffset + pageBoundary.pageWidth - check_width;
      }
      // if (x > this.pageWidth - this.deltaXOfPageWidth) {
      //   return;
      // }
      let addFieldToHistory = {
        data: checkBoxElement,
        action: "add",
        index: this.elements.length,
      };
      this.history.push(addFieldToHistory);
      this.elements.push(checkBoxElement);
      this.getFieldsFromElements();
    },
    addYesOrNo() {
      let indx = this.getLastIndexOfElement("YES_OR_NO");
      indx = indx + 1;
      // let offset = this.getElementYOffet("yesOrNoEle");
      let font = {
        name: "Helvetica",
        size: 16,
        style: 0,
        color: "#000000",
      };

      let fontOfLast = this.getTheLastFont();
      if (fontOfLast !== null) {
        font = fontOfLast;
      }
      let fieldWidth = (140 * font.size) / 16;
      let fieldHeight = 1.5 * font.size;
      let yesOrNoMetaData = {
        type: "YES_OR_NO",
        section: "input",
        style: "background:#cbe2d8;",

        font: font,

        field_type: "CUSTOM_FIELD",
        index: indx,
        label: "Yes or No " + indx,
        placeholder: "Yes or No " + indx,
        required: false,
        filled_by: this.recipientSelection || "SENDER_OR_RECEIVER",
        is_entity_variable: false,
        global_variable_entity_field: "",
        files: [],
        list_data: [],
        list_data_selected_value_ref: "",
        sample_files: [],
        alignStyles: "left",
        requiredFiles: 1,
        file_names: [],
        options: [],
      };
      let positionSize = {
        x:
          this.mouseX +
          this.$refs.formBuilder.scrollLeft -
          this.$refs.formBuilder.getBoundingClientRect().x -
          this.deltaX,
        y:
          this.mouseY +
          this.$refs.formBuilder.scrollTop -
          this.$refs.formBuilder.getBoundingClientRect().y -
          this.deltaY +
          this.dragItemHeight -
          fieldHeight,
        height: fieldHeight,
        width: fieldWidth,
      };
      let yesOrNoElement = {
        ...yesOrNoMetaData,
        ...positionSize,
      };
      const x =
        this.mouseX +
        this.$refs.formBuilder.scrollLeft -
        this.$refs.formBuilder.getBoundingClientRect().x -
        this.deltaX;

      // if (x > this.pageWidth - this.deltaXOfPageWidth) {
      //   return;
      // }
      const y =
        this.mouseY +
        this.$refs.formBuilder.scrollTop -
        this.$refs.formBuilder.getBoundingClientRect().y -
        this.deltaY +
        this.dragItemHeight -
        fieldHeight;

      let pageBoundary = this.getPagesBoundaries(y);
      if (
        pageBoundary &&
        // pageBoundary.pageOffset &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          // x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
          x >= pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        return;
      }
      if (
        pageBoundary &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        yesOrNoElement.x =
          pageBoundary.pageOffset + pageBoundary.pageWidth - fieldWidth;
      }
      let addFieldToHistory = {
        data: yesOrNoElement,
        action: "add",
        index: this.elements.length,
      };
      this.history.push(addFieldToHistory);
      this.elements.push(yesOrNoElement);
      this.getFieldsFromElements();
    },
    addDateElement(item) {
      let indx = this.getLastIndexOfElement("DATE");
      indx = indx + 1;
      // let offset = this.getElementYOffet("dateEle");
      let font = {
        name: "Helvetica",
        size: 16,
        style: 0,
        color: "#000000",
      };

      let fontOfLast = this.getTheLastFont();
      if (fontOfLast !== null) {
        font = fontOfLast;
      }
      let fieldWidth = (180 * font.size) / 16;
      let fieldHeight = this.openCk ? 24 : font.size * 1.5;
      let DateMetaData = {
        type: "DATE",
        section: "input",
        style: "background:#cbe2d8;",
        font: font,
        index: indx,
        label: "Date " + indx,
        placeholder: "Select Date",
        required: this.recipientSelection ? true : false,
        filled_by: this.openCk
          ? item.filled_by
          : this.recipientSelection || "SENDER_OR_RECEIVER",
        is_entity_variable: false,
        global_variable_entity_field: "",
        value: "",
        class: "customFieldsData",
        files: [],
        sample_files: [],
        dateSelection: "none",
        disable_future_date: false,
        requiredFiles: 1,
        file_names: [],
        options: [],
        list_data: [],
        list_data_selected_value_ref: "",
        boxes: [],
        alignStyles: "left",
        is_use_boxes: false,
        boxNumber: 0,
        boxWidth: 20,
      };
      let positionSize = {
        x: this.openCk
          ? item.x
          : this.mouseX +
          this.$refs.formBuilder.scrollLeft -
          this.$refs.formBuilder.getBoundingClientRect().x -
          this.deltaX,
        y: this.openCk
          ? item.y
          : this.mouseY +
          this.$refs.formBuilder.scrollTop -
          this.$refs.formBuilder.getBoundingClientRect().y -
          this.deltaY +
          this.dragItemHeight -
          fieldHeight,
        height: this.openCk ? item.height : fieldHeight,
        width: this.openCk ? item.width : fieldWidth,
      };
      let DateElement = {
        ...DateMetaData,
        ...positionSize,
      };

      const x = this.openCk
        ? item.x
        : this.mouseX +
        this.$refs.formBuilder.scrollLeft -
        this.$refs.formBuilder.getBoundingClientRect().x -
        this.deltaX;

      // if (x > this.pageWidth - this.deltaXOfPageWidth) {
      //   return;
      // }

      const y = this.openCk
        ? item.y
        : this.mouseY +
        this.$refs.formBuilder.scrollTop -
        this.$refs.formBuilder.getBoundingClientRect().y -
        this.deltaY +
        this.dragItemHeight -
        fieldHeight;
      let pageBoundary = this.openCk ? 1300 : this.getPagesBoundaries(y);
      if (
        pageBoundary &&
        // pageBoundary.pageOffset &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          // x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
          x >= pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        return;
      }
      if (
        pageBoundary &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        DateElement.x =
          pageBoundary.pageOffset + pageBoundary.pageWidth - fieldWidth;
      }
      let addFieldToHistory = {
        data: DateElement,
        action: "add",
        index: this.elements.length,
      };
      this.history.push(addFieldToHistory);
      this.elements.push(DateElement);
      this.getFieldsFromElements();
    },
    addDateTime() {
      let indx = this.getLastIndexOfElement("DATE_TIME");
      indx = indx + 1;
      // let offset = this.getElementYOffet("dateEle");
      let font = {
        name: "Helvetica",
        size: 16,
        style: 0,
        color: "#000000",
      };

      let fontOfLast = this.getTheLastFont();
      if (fontOfLast !== null) {
        font = fontOfLast;
      }
      let fieldWidth = (180 * font.size) / 16;
      let fieldHeight = font.size * 1.5;
      let DateMetaData = {
        type: "DATE_TIME",
        section: "input",
        style: "background:#cbe2d8;",
        font: font,
        index: indx,
        label: "Date Time " + indx,
        placeholder: "Select date and time",
        required: this.recipientSelection ? true : false,
        filled_by: this.recipientSelection || "SENDER_OR_RECEIVER",
        is_entity_variable: false,
        global_variable_entity_field: "",
        value: "",
        files: [],
        list_data: [],
        list_data_selected_value_ref: "",
        sample_files: [],
        requiredFiles: 1,
        file_names: [],
        alignStyles: "left",
        options: [],
      };
      let positionSize = {
        x:
          this.mouseX +
          this.$refs.formBuilder.scrollLeft -
          this.$refs.formBuilder.getBoundingClientRect().x -
          this.deltaX,
        y:
          this.mouseY +
          this.$refs.formBuilder.scrollTop -
          this.$refs.formBuilder.getBoundingClientRect().y -
          this.deltaY +
          this.dragItemHeight -
          fieldHeight,
        height: fieldHeight,
        width: fieldWidth,
      };
      let DateElement = {
        ...DateMetaData,
        ...positionSize,
      };

      const x =
        this.mouseX +
        this.$refs.formBuilder.scrollLeft -
        this.$refs.formBuilder.getBoundingClientRect().x -
        this.deltaX;

      // if (x > this.pageWidth - this.deltaXOfPageWidth) {
      //   return;
      // }

      const y =
        this.mouseY +
        this.$refs.formBuilder.scrollTop -
        this.$refs.formBuilder.getBoundingClientRect().y -
        this.deltaY +
        this.dragItemHeight -
        fieldHeight;
      let pageBoundary = this.getPagesBoundaries(y);
      if (
        pageBoundary &&
        // pageBoundary.pageOffset &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          // x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
          x >= pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        return;
      }
      if (
        pageBoundary &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        DateElement.x =
          pageBoundary.pageOffset + pageBoundary.pageWidth - fieldWidth;
      }
      let addFieldToHistory = {
        data: DateElement,
        action: "add",
        index: this.elements.length,
      };
      this.history.push(addFieldToHistory);
      this.elements.push(DateElement);
      this.getFieldsFromElements();
    },
    addDateTimeRange() {
      let indx = this.getLastIndexOfElement("DATE_TIME_RANGE");
      indx = indx + 1;
      // let offset = this.getElementYOffet("dateEle");
      let font = {
        name: "Helvetica",
        size: 16,
        style: 0,
        color: "#000000",
      };

      let fontOfLast = this.getTheLastFont();
      if (fontOfLast !== null) {
        font = fontOfLast;
      }
      let fieldWidth = 400;
      let fieldHeight = 40;
      let DateTimeRangeMetaData = {
        type: "DATE_TIME_RANGE",
        section: "input",
        style: "background:#cbe2d8;",
        font: font,
        index: indx,
        label: "Date Time Range " + indx,
        placeholder: "Select date time Range",
        required: this.recipientSelection ? true : false,
        filled_by: this.recipientSelection || "SENDER_OR_RECEIVER",
        is_entity_variable: false,
        global_variable_entity_field: "",
        value: "",
        files: [],
        list_data: [],
        list_data_selected_value_ref: "",
        sample_files: [],
        requiredFiles: 1,
        file_names: [],
        alignStyles: "left",
        options: [],
      };
      let positionSize = {
        x:
          this.mouseX +
          this.$refs.formBuilder.scrollLeft -
          this.$refs.formBuilder.getBoundingClientRect().x -
          this.deltaX,
        y:
          this.mouseY +
          this.$refs.formBuilder.scrollTop -
          this.$refs.formBuilder.getBoundingClientRect().y -
          this.deltaY +
          this.dragItemHeight -
          fieldHeight,
        height: fieldHeight,
        width: fieldWidth,
      };
      let DateTimeRangeElement = {
        ...DateTimeRangeMetaData,
        ...positionSize,
      };

      const x =
        this.mouseX +
        this.$refs.formBuilder.scrollLeft -
        this.$refs.formBuilder.getBoundingClientRect().x -
        this.deltaX;

      // if (x > this.pageWidth - this.deltaXOfPageWidth) {
      //   return;
      // }

      const y =
        this.mouseY +
        this.$refs.formBuilder.scrollTop -
        this.$refs.formBuilder.getBoundingClientRect().y -
        this.deltaY +
        this.dragItemHeight -
        fieldHeight;
      let pageBoundary = this.getPagesBoundaries(y);
      if (
        pageBoundary &&
        // pageBoundary.pageOffset &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          // x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
          x >= pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        return;
      }
      if (
        pageBoundary &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        DateTimeRangeElement.x =
          pageBoundary.pageOffset + pageBoundary.pageWidth - fieldWidth;
      }
      let addFieldToHistory = {
        data: DateTimeRangeElement,
        action: "add",
        index: this.elements.length,
      };
      this.history.push(addFieldToHistory);
      this.elements.push(DateTimeRangeElement);
      this.getFieldsFromElements();
    },
    addDateRange() {
      let indx = this.getLastIndexOfElement("DATE_RANGE");
      indx = indx + 1;
      // let offset = this.getElementYOffet("dateEle");
      let font = {
        name: "Helvetica",
        size: 16,
        style: 0,
        color: "#000000",
      };

      let fontOfLast = this.getTheLastFont();
      if (fontOfLast !== null) {
        font = fontOfLast;
      }
      let fieldWidth = 400;
      let fieldHeight = 40;
      let DateRangeMetaData = {
        type: "DATE_RANGE",
        section: "input",
        style: "background:#cbe2d8;",
        font: font,
        index: indx,
        label: "Date Range " + indx,
        placeholder: "Select date Range",
        required: this.recipientSelection ? true : false,
        filled_by: this.recipientSelection || "SENDER_OR_RECEIVER",
        is_entity_variable: false,
        global_variable_entity_field: "",
        value: "",
        files: [],
        list_data: [],
        list_data_selected_value_ref: "",
        sample_files: [],
        requiredFiles: 1,
        file_names: [],
        alignStyles: "left",
        options: [],
      };
      let positionSize = {
        x:
          this.mouseX +
          this.$refs.formBuilder.scrollLeft -
          this.$refs.formBuilder.getBoundingClientRect().x -
          this.deltaX,
        y:
          this.mouseY +
          this.$refs.formBuilder.scrollTop -
          this.$refs.formBuilder.getBoundingClientRect().y -
          this.deltaY +
          this.dragItemHeight -
          fieldHeight,
        height: fieldHeight,
        width: fieldWidth,
      };
      let DateRangeElement = {
        ...DateRangeMetaData,
        ...positionSize,
      };

      const x =
        this.mouseX +
        this.$refs.formBuilder.scrollLeft -
        this.$refs.formBuilder.getBoundingClientRect().x -
        this.deltaX;

      // if (x > this.pageWidth - this.deltaXOfPageWidth) {
      //   return;
      // }

      const y =
        this.mouseY +
        this.$refs.formBuilder.scrollTop -
        this.$refs.formBuilder.getBoundingClientRect().y -
        this.deltaY +
        this.dragItemHeight -
        fieldHeight;
      let pageBoundary = this.getPagesBoundaries(y);
      if (
        pageBoundary &&
        // pageBoundary.pageOffset &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          // x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
          x >= pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        return;
      }
      if (
        pageBoundary &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        DateRangeElement.x =
          pageBoundary.pageOffset + pageBoundary.pageWidth - fieldWidth;
      }
      let addFieldToHistory = {
        data: DateRangeElement,
        action: "add",
        index: this.elements.length,
      };
      this.history.push(addFieldToHistory);
      this.elements.push(DateRangeElement);
      this.getFieldsFromElements();
    },
    addTime() {
      let indx = this.getLastIndexOfElement("TIME");
      indx = indx + 1;
      // let offset = this.getElementYOffet("dateEle");
      let font = {
        name: "Helvetica",
        size: 16,
        style: 0,
        color: "#000000",
      };

      let fontOfLast = this.getTheLastFont();
      if (fontOfLast !== null) {
        font = fontOfLast;
      }
      let fieldWidth = (180 * font.size) / 16;
      let fieldHeight = font.size * 1.5;
      let TimeMetaData = {
        type: "TIME",
        section: "input",
        style: "background:#cbe2d8;",
        font: font,
        index: indx,
        label: " Time " + indx,
        placeholder: "Select time",
        required: this.recipientSelection ? true : false,
        filled_by: this.recipientSelection || "SENDER_OR_RECEIVER",
        is_entity_variable: false,
        global_variable_entity_field: "",
        value: "",
        files: [],
        list_data: [],
        list_data_selected_value_ref: "",
        sample_files: [],
        requiredFiles: 1,
        file_names: [],
        alignStyles: "left",
        options: [],
      };
      let positionSize = {
        x:
          this.mouseX +
          this.$refs.formBuilder.scrollLeft -
          this.$refs.formBuilder.getBoundingClientRect().x -
          this.deltaX,
        y:
          this.mouseY +
          this.$refs.formBuilder.scrollTop -
          this.$refs.formBuilder.getBoundingClientRect().y -
          this.deltaY +
          this.dragItemHeight -
          fieldHeight,
        height: fieldHeight,
        width: fieldWidth,
      };
      let TimeElement = {
        ...TimeMetaData,
        ...positionSize,
      };

      const x =
        this.mouseX +
        this.$refs.formBuilder.scrollLeft -
        this.$refs.formBuilder.getBoundingClientRect().x -
        this.deltaX;

      // if (x > this.pageWidth - this.deltaXOfPageWidth) {
      //   return;
      // }

      const y =
        this.mouseY +
        this.$refs.formBuilder.scrollTop -
        this.$refs.formBuilder.getBoundingClientRect().y -
        this.deltaY +
        this.dragItemHeight -
        fieldHeight;

      let pageBoundary = this.getPagesBoundaries(y);
      if (
        pageBoundary &&
        // pageBoundary.pageOffset &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          // x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
          x >= pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        return;
      }
      if (
        pageBoundary &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        TimeElement.x =
          pageBoundary.pageOffset + pageBoundary.pageWidth - fieldWidth;
      }
      let addFieldToHistory = {
        data: TimeElement,
        action: "add",
        index: this.elements.length,
      };
      this.history.push(addFieldToHistory);
      this.elements.push(TimeElement);
      this.getFieldsFromElements();
    },

    // addRadio() {
    //   let indx = this.getLastIndexOfElement("RADIO");
    //   indx = indx + 1;

    //   let font = {
    //     name: "Helvetica",
    //     size: 16,
    //     style: 0,
    //     color: "#000000",
    //   };

    //   let fontOfLast = this.getTheLastFont();
    //   if (fontOfLast !== null) {
    //     font = fontOfLast;
    //   }
    //   let fieldWidth = (140 * font.size) / 16;
    //   let fieldHeight = 1.5 * font.size;
    //   let radioMetaData = {
    //     type: "Radio",
    //     section: "input",
    //     style: "background:#cbe2d8;",

    //     font: font,

    //     field_type: "CUSTOM_FIELD",
    //     index: indx,
    //     label: "Radio " + indx,
    //     placeholder: "Radio " + indx,
    //     required: false,
    //     filled_by: this.recipientSelection || "SENDER_OR_RECEIVER",
    //     files: [],
    //     sample_files: [],
    //     requiredFiles: 1,
    //     file_names: [],
    //     options: [],
    //   }
    //   let positionSize ={
    //     x:
    //     this.mouseX +
    //     this.$refs.formBuilder.scrollLeft -
    //     this.$refs.formBuilder.getBoundingClientRect().x -
    //     this.deltaX,
    //     y:
    //       this.mouseY +
    //       this.$refs.formBuilder.scrollTop -
    //       this.$refs.formBuilder.getBoundingClientRect().y -
    //       this.deltaY +
    //       this.dragItemHeight -
    //       fieldHeight,
    //       height: fieldHeight,
    //       width: fieldWidth,
    //   }
    //   let radioElement = {
    //     ...radioMetaData,
    //     ...positionSize,
    //   };
    //   const x =
    //     this.mouseX +
    //     this.$refs.formBuilder.scrollLeft -
    //     this.$refs.formBuilder.getBoundingClientRect().x -
    //     this.deltaX;

    //   // if (x > this.pageWidth - this.deltaXOfPageWidth) {
    //   //   return;
    //   // }
    //   const y =
    //     this.mouseY +
    //     this.$refs.formBuilder.scrollTop -
    //     this.$refs.formBuilder.getBoundingClientRect().y -
    //     this.deltaY +
    //     this.dragItemHeight -
    //     fieldHeight;

    //   let pageBoundary = this.getPagesBoundaries(y);
    //   if (
    //     pageBoundary &&
    //     // pageBoundary.pageOffset &&
    //     pageBoundary.pageWidth &&
    //     (x < pageBoundary.pageOffset ||
    //       // x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
    //       x >= pageBoundary.pageOffset + pageBoundary.pageWidth)
    //   ) {
    //     return;
    //   }
    //   if (
    //     pageBoundary &&
    //     pageBoundary.pageWidth &&
    //     (x < pageBoundary.pageOffset ||
    //       x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
    //   ) {
    //     radioElement.x = pageBoundary.pageOffset + pageBoundary.pageWidth - fieldWidth;
    //   }
    //   let addFieldToHistory={
    //     data:radioElement,
    //     action:'add',
    //     index:this.elements.length,
    //   }
    //   this.history.push(addFieldToHistory)
    //   this.elements.push(radioElement);
    //   this.getFieldsFromElements();
    // },
    addList() {
      let indx = this.getLastIndexOfElement("LIST");
      indx = indx + 1;
      let font = {
        name: "Helvetica",
        size: 16,
        style: 0,
        color: "#000000",
      };

      let fontOfLast = this.getTheLastFont();
      if (fontOfLast !== null) {
        font = fontOfLast;
      }
      let fieldWidth = (180 * font.size) / 16;
      let fieldHeight = font.size * 1.5;
      let TimeMetaData = {
        type: "LIST",
        section: "input",
        style: "background:#cbe2d8;",
        font: font,
        index: indx,
        label: "List" + indx,
        placeholder: "Select Value",
        required: this.recipientSelection ? true : false,
        filled_by: this.recipientSelection || "SENDER_OR_RECEIVER",
        is_entity_variable: false,
        global_variable_entity_field: "",
        value: "",
        files: [],
        sample_files: [],
        list_data: [],
        list_data_selected_value_ref: "",
        requiredFiles: 1,
        file_names: [],
        alignStyles: "left",
        options: [],
      };
      let positionSize = {
        x:
          this.mouseX +
          this.$refs.formBuilder.scrollLeft -
          this.$refs.formBuilder.getBoundingClientRect().x -
          this.deltaX,
        y:
          this.mouseY +
          this.$refs.formBuilder.scrollTop -
          this.$refs.formBuilder.getBoundingClientRect().y -
          this.deltaY +
          this.dragItemHeight -
          fieldHeight,
        height: fieldHeight,
        width: fieldWidth,
      };
      let TimeElement = {
        ...TimeMetaData,
        ...positionSize,
      };

      const x =
        this.mouseX +
        this.$refs.formBuilder.scrollLeft -
        this.$refs.formBuilder.getBoundingClientRect().x -
        this.deltaX;

      const y =
        this.mouseY +
        this.$refs.formBuilder.scrollTop -
        this.$refs.formBuilder.getBoundingClientRect().y -
        this.deltaY +
        this.dragItemHeight -
        fieldHeight;
      let pageBoundary = this.getPagesBoundaries(y);
      if (
        pageBoundary &&
        // pageBoundary.pageOffset &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          // x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
          x >= pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        return;
      }
      if (
        pageBoundary &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        TimeElement.x =
          pageBoundary.pageOffset + pageBoundary.pageWidth - fieldWidth;
      }
      let addFieldToHistory = {
        data: TimeElement,
        action: "add",
        index: this.elements.length,
      };
      this.history.push(addFieldToHistory);
      this.elements.push(TimeElement);
      let index = this.elements.length - 1;
      this.addItemDataDialogVisible = true;
      const choosenElement = JSON.parse(JSON.stringify(this.elements[index]));
      this.selectedItem = { ...{}, ...choosenElement };
      this.selectedItemIndex = index;
      this.getFieldsFromElements();
    },

    addTimeRange() {
      let indx = this.getLastIndexOfElement("TIME_RANGE");
      indx = indx + 1;
      // let offset = this.getElementYOffet("dateEle");
      let font = {
        name: "Helvetica",
        size: 16,
        style: 0,
        color: "#000000",
      };

      let fontOfLast = this.getTheLastFont();
      if (fontOfLast !== null) {
        font = fontOfLast;
      }
      let fieldWidth = 400;
      let fieldHeight = 40;
      let TimeRangeMetaData = {
        type: "TIME_RANGE",
        section: "input",
        style: "background:#cbe2d8;",
        font: font,
        index: indx,
        label: "Time Range " + indx,
        placeholder: "Select Time Range",
        required: this.recipientSelection ? true : false,
        filled_by: this.recipientSelection || "SENDER_OR_RECEIVER",
        is_entity_variable: false,
        global_variable_entity_field: "",
        value: "",
        files: [],
        list_data: [],
        list_data_selected_value_ref: "",
        sample_files: [],
        requiredFiles: 1,
        file_names: [],
        alignStyles: "left",
        options: [],
      };
      let positionSize = {
        x:
          this.mouseX +
          this.$refs.formBuilder.scrollLeft -
          this.$refs.formBuilder.getBoundingClientRect().x -
          this.deltaX,
        y:
          this.mouseY +
          this.$refs.formBuilder.scrollTop -
          this.$refs.formBuilder.getBoundingClientRect().y -
          this.deltaY +
          this.dragItemHeight -
          fieldHeight,
        height: fieldHeight,
        width: fieldWidth,
      };
      let TimeRangeElement = {
        ...TimeRangeMetaData,
        ...positionSize,
      };

      const x =
        this.mouseX +
        this.$refs.formBuilder.scrollLeft -
        this.$refs.formBuilder.getBoundingClientRect().x -
        this.deltaX;

      // if (x > this.pageWidth - this.deltaXOfPageWidth) {
      //   return;
      // }

      const y =
        this.mouseY +
        this.$refs.formBuilder.scrollTop -
        this.$refs.formBuilder.getBoundingClientRect().y -
        this.deltaY +
        this.dragItemHeight -
        fieldHeight;
      let pageBoundary = this.getPagesBoundaries(y);
      if (
        pageBoundary &&
        // pageBoundary.pageOffset &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          // x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
          x >= pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        return;
      }
      if (
        pageBoundary &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        TimeRangeElement.x =
          pageBoundary.pageOffset + pageBoundary.pageWidth - fieldWidth;
      }
      let addFieldToHistory = {
        data: TimeRangeElement,
        action: "add",
        index: this.elements.length,
      };
      this.history.push(addFieldToHistory);
      this.elements.push(TimeRangeElement);
      this.getFieldsFromElements();
    },
    addFixedTime() {
      let indx = this.getLastIndexOfElement("FIXED_TIME");
      indx = indx + 1;
      // let offset = this.getElementYOffet("dateEle");
      let font = {
        name: "Helvetica",
        size: 16,
        style: 0,
        color: "#000000",
      };

      let fontOfLast = this.getTheLastFont();
      if (fontOfLast !== null) {
        font = fontOfLast;
      }
      let fieldWidth = (180 * font.size) / 16;
      let fieldHeight = font.size * 1.5;
      let FixedTimeMetaData = {
        type: "FIXED_TIME",
        section: "input",
        style: "background:#cbe2d8;",
        font: font,
        index: indx,
        label: " Fixed Time " + indx,
        placeholder: "Select Fixed time",
        required: this.recipientSelection ? true : false,
        filled_by: this.recipientSelection || "SENDER_OR_RECEIVER",
        is_entity_variable: false,
        global_variable_entity_field: "",
        value: "",
        files: [],
        list_data: [],
        list_data_selected_value_ref: "",
        sample_files: [],
        requiredFiles: 1,
        file_names: [],
        alignStyles: "left",
        options: [],
        time_range: [
          new Date(2016, 9, 10, 0, 0),
          new Date(2016, 9, 10, 23, 59, 59),
        ],
        step_time: "30",
      };
      let positionSize = {
        x:
          this.mouseX +
          this.$refs.formBuilder.scrollLeft -
          this.$refs.formBuilder.getBoundingClientRect().x -
          this.deltaX,
        y:
          this.mouseY +
          this.$refs.formBuilder.scrollTop -
          this.$refs.formBuilder.getBoundingClientRect().y -
          this.deltaY +
          this.dragItemHeight -
          fieldHeight,
        height: fieldHeight,
        width: fieldWidth,
      };
      let FixedTimeElement = {
        ...FixedTimeMetaData,
        ...positionSize,
      };

      const x =
        this.mouseX +
        this.$refs.formBuilder.scrollLeft -
        this.$refs.formBuilder.getBoundingClientRect().x -
        this.deltaX;

      // if (x > this.pageWidth - this.deltaXOfPageWidth) {
      //   return;
      // }

      const y =
        this.mouseY +
        this.$refs.formBuilder.scrollTop -
        this.$refs.formBuilder.getBoundingClientRect().y -
        this.deltaY +
        this.dragItemHeight -
        fieldHeight;
      let pageBoundary = this.getPagesBoundaries(y);
      if (
        pageBoundary &&
        // pageBoundary.pageOffset &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          // x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
          x >= pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        return;
      }
      if (
        pageBoundary &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        FixedTimeElement.x =
          pageBoundary.pageOffset + pageBoundary.pageWidth - fieldWidth;
      }
      let addFieldToHistory = {
        data: FixedTimeElement,
        action: "add",
        index: this.elements.length,
      };
      this.history.push(addFieldToHistory);
      this.elements.push(FixedTimeElement);
      this.getFieldsFromElements();
    },
    addWeekdays() {
      let indx = this.getLastIndexOfElement("WEEKDAYS");
      indx = indx + 1;
      // let offset = this.getElementYOffet("multiSlectedEle");
      let font = {
        name: "Helvetica",
        size: 16,
        style: 0,
        color: "#000000",
      };

      let fontOfLast = this.getTheLastFont();
      if (fontOfLast !== null) {
        font = fontOfLast;
      }
      let fieldWidth = (200 * font.size * 1.5) / 16;
      let fieldHeight = 2 * font.size;
      const x =
        this.mouseX +
        this.$refs.formBuilder.scrollLeft -
        this.$refs.formBuilder.getBoundingClientRect().x -
        this.deltaX;
      const y =
        this.mouseY +
        this.$refs.formBuilder.scrollTop -
        this.$refs.formBuilder.getBoundingClientRect().y -
        this.deltaY +
        this.dragItemHeight -
        fieldHeight;

      let weekdaysMetaData = {
        type: "WEEKDAYS",
        section: "input",
        style: "background:#cbe2d8;",
        value: "",
        files: [],
        sample_files: [],
        requiredFiles: 1,
        file_names: [],
        options: [],
        font: font,
        list_data: [],
        list_data_selected_value_ref: "",
        index: indx,
        label: "Weekdays " + indx,
        placeholder: "Please select...",
        alignStyles: "left",
        required: this.recipientSelection ? true : false,
        filled_by: this.recipientSelection || "SENDER_OR_RECEIVER",
        is_entity_variable: false,
        global_variable_entity_field: "",
      };
      let positionSize = {
        x:
          this.mouseX +
          this.$refs.formBuilder.scrollLeft -
          this.$refs.formBuilder.getBoundingClientRect().x -
          this.deltaX,
        y:
          this.mouseY +
          this.$refs.formBuilder.scrollTop -
          this.$refs.formBuilder.getBoundingClientRect().y -
          this.deltaY +
          this.dragItemHeight -
          fieldHeight,
        height: fieldHeight,
        width: fieldWidth,
      };

      let weekdaysElement = {
        ...weekdaysMetaData,
        ...positionSize,
      };

      // if (x > this.pageWidth - this.deltaXOfPageWidth) {
      //   return;
      // }

      let pageBoundary = this.getPagesBoundaries(y);
      if (
        pageBoundary &&
        // pageBoundary.pageOffset &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          // x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
          x >= pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        return;
      }
      if (
        pageBoundary &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        weekdaysElement.x =
          pageBoundary.pageOffset + pageBoundary.pageWidth - fieldWidth;
      }

      let addFieldToHistory = {
        data: weekdaysElement,
        action: "add",
        index: this.elements.length,
      };
      this.history.push(addFieldToHistory);
      this.elements.push(weekdaysElement);
      let index = this.elements.length - 1;
      // this.addItemDataDialogVisible = true;
      const choosenElement = JSON.parse(JSON.stringify(this.elements[index]));
      this.selectedItem = { ...{}, ...choosenElement };
      this.selectedItemIndex = index;
      this.getFieldsFromElements();
    },
    getLastElementOfType(type) {
      let typeEle = this.elements.filter((element) => element.type == type);
      if (typeEle && typeEle.length) {
        typeEle = typeEle.sort((a, b) => a.index - b.index);
        return typeEle[typeEle.length - 1] && typeEle[typeEle.length - 1]
          ? typeEle[typeEle.length - 1]
          : null;
      }
      return null;
    },

    addDateSigned() {
      if (this.recipientSelection) {
        let indx = this.getLastIndexOfElement("DATE_SIGNED");
        indx = indx + 1;
        // let offset = this.getElementYOffet("dateSingedEle");
        let font = {
          name: "Helvetica",
          size: 16,
          style: 0,
          color: "#000000",
        };
        let fieldWidth = (120 * font.size) / 16;
        let fieldHeight = 1.5 * font.size;
        let sizeOfLast = this.getLastElementOfType("DATE_SIGNED");
        if (sizeOfLast !== null) {
          fieldWidth = sizeOfLast.width;
          fieldHeight = sizeOfLast.height;
        }
        let fontOfLast = this.getTheLastFont();
        if (fontOfLast !== null) {
          font = fontOfLast;
        }
        let DateSignedMetaData = {
          type: "DATE_SIGNED",
          section: "input",
          style: "background:#cbe2d8;",
          font: font,
          field_type: "CUSTOM_FIELD",
          signature_field_id: "",
          signature_field_key: "",
          signature_field: {},
          list_data: [],
          list_data_selected_value_ref: "",
          index: indx,
          label: "Date Signed " + indx,
          placeholder: "Date signed",
          alignStyles: "left",
          required: false,
          filled_by: this.recipientSelection || "SENDER_OR_RECEIVER",
          is_entity_variable: false,
          global_variable_entity_field: "",
        };
        let positionSize = {
          x:
            this.mouseX +
            this.$refs.formBuilder.scrollLeft -
            this.$refs.formBuilder.getBoundingClientRect().x -
            this.deltaX,
          y:
            this.mouseY +
            this.$refs.formBuilder.scrollTop -
            this.$refs.formBuilder.getBoundingClientRect().y -
            this.deltaY +
            this.dragItemHeight -
            fieldHeight,
          height: fieldHeight,
          width: fieldWidth,
        };
        let DateSignedElement = {
          ...DateSignedMetaData,
          ...positionSize,
        };

        if (
          this.checkElementIsBefore("SIGNATURE", this.recipientSelection) &&
          this.recipientSelection != "SENDER"
        ) {
          const x =
            this.mouseX +
            this.$refs.formBuilder.scrollLeft -
            this.$refs.formBuilder.getBoundingClientRect().x -
            this.deltaX;
          const y =
            this.mouseY +
            this.$refs.formBuilder.scrollTop -
            this.$refs.formBuilder.getBoundingClientRect().y -
            this.deltaY +
            this.dragItemHeight -
            fieldHeight;

          // if (x > this.pageWidth - this.deltaXOfPageWidth) {
          //   return;
          // }

          let pageBoundary = this.getPagesBoundaries(y);
          if (
            pageBoundary &&
            // pageBoundary.pageOffset &&
            pageBoundary.pageWidth &&
            (x < pageBoundary.pageOffset ||
              // x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
              x >= pageBoundary.pageOffset + pageBoundary.pageWidth)
          ) {
            return;
          }
          if (
            pageBoundary &&
            pageBoundary.pageWidth &&
            (x < pageBoundary.pageOffset ||
              x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
          ) {
            DateSignedElement.x =
              pageBoundary.pageOffset + pageBoundary.pageWidth - fieldWidth;
          }
          let addFieldToHistory = {
            data: DateSignedElement,
            action: "add",
            index: this.elements.length,
          };
          this.history.push(addFieldToHistory);
          this.elements.push(DateSignedElement);
        } else if (
          (this.checkElementIsBefore("SIGNATURE", this.recipientSelection) ||
            this.checkElementIsBefore(
              "my-signature",
              this.recipientSelection
            )) &&
          this.recipientSelection == "SENDER"
        ) {
          let fieldWidth = (120 * font.size) / 16;
          let fieldHeight = 1.5 * font.size;
          let sizeOfLast = this.getLastElementOfType("DATE_SIGNED");
          if (sizeOfLast !== null) {
            fieldWidth = sizeOfLast.width;
            fieldHeight = sizeOfLast.height;
          }
          let beforeDateSignedMetaData = {
            type: "DATE_SIGNED",
            section: "input",
            style: "background:#cbe2d8;",
            font: font,

            field_type: "CUSTOM_FIELD",
            signature_field_id: "",
            signature_field_key: "",
            signature_field: {},
            index: indx,
            label: "Date Signed " + indx,
            placeholder: "Date signed",
            required: false,
            filled_by: this.recipientSelection || "SENDER_OR_RECEIVER",
            is_entity_variable: false,
            global_variable_entity_field: "",
          };
          let positionSize = {
            x:
              this.mouseX +
              this.$refs.formBuilder.scrollLeft -
              this.$refs.formBuilder.getBoundingClientRect().x -
              this.deltaX,
            y:
              this.mouseY +
              this.$refs.formBuilder.scrollTop -
              this.$refs.formBuilder.getBoundingClientRect().y -
              this.deltaY +
              this.dragItemHeight -
              fieldHeight,
            height: fieldHeight,
            width: fieldWidth,
          };
          let beforDateSignedElement = {
            ...beforeDateSignedMetaData,
            ...positionSize,
          };
          const x =
            this.mouseX +
            this.$refs.formBuilder.scrollLeft -
            this.$refs.formBuilder.getBoundingClientRect().x -
            this.deltaX;
          const y =
            this.mouseY +
            this.$refs.formBuilder.scrollTop -
            this.$refs.formBuilder.getBoundingClientRect().y -
            this.deltaY +
            this.dragItemHeight -
            fieldHeight;
          // if (x > this.pageWidth - this.deltaXOfPageWidth) {
          //   return;
          // }
          let pageBoundary = this.getPagesBoundaries(y);
          if (
            pageBoundary &&
            // pageBoundary.pageOffset &&
            pageBoundary.pageWidth &&
            (x < pageBoundary.pageOffset ||
              // x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
              x >= pageBoundary.pageOffset + pageBoundary.pageWidth)
          ) {
            return;
          }
          if (
            pageBoundary &&
            pageBoundary.pageWidth &&
            (x < pageBoundary.pageOffset ||
              x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
          ) {
            beforDateSignedElement.x =
              pageBoundary.pageOffset + pageBoundary.pageWidth - fieldWidth;
          }
          let addFieldToHistory = {
            data: beforDateSignedElement,
            action: "add",
            index: this.elements.length,
          };
          this.history.push(addFieldToHistory);
          this.elements.push(beforDateSignedElement);
        } else {
          this.$message({
            message:
              "Sign Date is linked to the recipient user's signature. Please include a Signature field.",
            type: "warning",
          });
        }
      } else {
        this.$message({
          message: "Please Select a Receipent User.",
          type: "warning",
        });
      }
    },
    addAttachment() {
      let indx = this.getLastIndexOfElement("ATTACHMENT");
      indx = indx + 1;
      // let offset = this.getElementYOffet("initialEle");
      if (this.recipientSelection) {
        const x =
          this.mouseX +
          this.$refs.formBuilder.scrollLeft -
          this.$refs.formBuilder.getBoundingClientRect().x -
          this.deltaX;

        // if (x > this.pageWidth - this.deltaXOfPageWidth) {
        //   return;
        // }
        const y =
          this.mouseY +
          this.$refs.formBuilder.scrollTop -
          this.$refs.formBuilder.getBoundingClientRect().y -
          this.deltaY +
          this.dragItemHeight -
          50;
        let pageBoundary = this.getPagesBoundaries(y);
        let attachmentMetaData = {
          type: "ATTACHMENT",
          section: "input",
          label: "Attachment " + indx,

          field_type: "CUSTOM_FIELD",
          value: "",
          files: [],
          sample_files: [],
          requiredFiles: 1,
          list_data: [],
          list_data_selected_value_ref: "",
          file_names: [],
          options: [],

          index: indx,
          text: "",
          color: "",
          font: {
            name: "Helvetica",
            size: 16,
            style: 0,
            color: "#000000",
          },
          required: this.recipientSelection ? true : false,
          filled_by: this.recipientSelection || "SENDER_OR_RECEIVER",
          is_entity_variable: false,
          global_variable_entity_field: "",
        };
        let positionSize = {
          x:
            this.mouseX +
            this.$refs.formBuilder.scrollLeft -
            this.$refs.formBuilder.getBoundingClientRect().x -
            this.deltaX,
          y:
            this.mouseY +
            this.$refs.formBuilder.scrollTop -
            this.$refs.formBuilder.getBoundingClientRect().y -
            this.deltaY +
            this.dragItemHeight -
            50,
          height: 50,
          width: 120,
        };
        let attachmentElement = {
          ...attachmentMetaData,
          ...positionSize,
        };
        if (
          pageBoundary &&
          // pageBoundary.pageOffset &&
          pageBoundary.pageWidth &&
          (x < pageBoundary.pageOffset ||
            // x + 120 > pageBoundary.pageOffset + pageBoundary.pageWidth)
            x >= pageBoundary.pageOffset + pageBoundary.pageWidth)
        ) {
          return;
        }
        if (
          pageBoundary &&
          pageBoundary.pageWidth &&
          (x < pageBoundary.pageOffset ||
            x + 120 > pageBoundary.pageOffset + pageBoundary.pageWidth)
        ) {
          attachmentElement.x =
            pageBoundary.pageOffset + pageBoundary.pageWidth - 120;
        }
        let addFieldToHistory = {
          data: attachmentElement,
          action: "add",
          index: this.elements.length,
        };
        this.history.push(addFieldToHistory);
        this.elements.push(attachmentElement);
        this.getFieldsFromElements();
      } else {
        this.$message({
          message: "Please Select a Receipent User.",
          type: "warning",
        });
      }
    },
    addNumber(item) {
      let indx = this.getLastIndexOfElement("NUMBER");
      indx = indx + 1;
      // let offset = this.getElementYOffet("numberEle");
      let font = {
        name: "Helvetica",
        size: 16,
        style: 0,
        color: "#000000",
      };

      let fontOfLast = this.getTheLastFont();
      if (fontOfLast !== null) {
        font = fontOfLast;
      }
      let fieldWidth = 150;
      let fieldHeight = this.openCk ? 24 : font.size * 1.5;
      let sizeOfLast = this.getTheLastSize();
      if (sizeOfLast !== null) {
        fieldWidth = sizeOfLast.width;
        // fieldHeight = sizeOfLast.height;
      }

      let numberMetaData = {
        type: "NUMBER",
        section: "input",
        font: font,
        style: "background:#cbe2d8;",
        index: indx,
        label: this.openCk ? "Number" : "Number " + indx,
        placeholder: "Enter Number",
        filled_by: this.openCk
          ? item.filled_by
          : this.recipientSelection || "SENDER_OR_RECEIVER",
        is_entity_variable: false,
        global_variable_entity_field: "",
        required: this.recipientSelection ? true : false,
        files: [],
        value: "",
        sample_files: [],
        class: "customFieldsData",
        requiredFiles: 1,
        file_names: [],
        list_data: [],
        alignStyles: "left",
        list_data_selected_value_ref: "",
        options: [],
        boxes: [],
        boxNumber: 0,
        boxWidth: 20,
        is_use_boxes: false,
      };

      let positionSize = {
        x: this.openCk
          ? item.x
          : this.mouseX +
          this.$refs.formBuilder.scrollLeft -
          this.$refs.formBuilder.getBoundingClientRect().x -
          this.deltaX,
        y: this.openCk
          ? item.y
          : this.mouseY +
          this.$refs.formBuilder.scrollTop -
          this.$refs.formBuilder.getBoundingClientRect().y -
          this.deltaY +
          this.dragItemHeight -
          fieldHeight,
        height: this.openCk ? item.height : fieldHeight,
        width: this.openCk ? item.width : fieldWidth,
      };

      const x = this.openCk
        ? item.x
        : this.mouseX +
        this.$refs.formBuilder.scrollLeft -
        this.$refs.formBuilder.getBoundingClientRect().x -
        this.deltaX;
      const y = this.openCk
        ? item.y
        : this.mouseY +
        this.$refs.formBuilder.scrollTop -
        this.$refs.formBuilder.getBoundingClientRect().y -
        this.deltaY +
        this.dragItemHeight -
        fieldHeight;
      let pageBoundary = this.openCk ? 1300 : this.getPagesBoundaries(y);
      if (
        pageBoundary &&
        // pageBoundary.pageOffset &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          // x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
          x >= pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        return;
      }
      if (
        pageBoundary &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        positionSize.x =
          pageBoundary.pageOffset + pageBoundary.pageWidth - fieldWidth;
      }
      // if (x > this.pageWidth - this.deltaXOfPageWidth) {
      //   return;
      // }

      let numberElement = {
        ...numberMetaData,
        ...positionSize,
      };
      let addFieldToHistory = {
        data: numberElement,
        action: "add",
        index: this.elements.length,
      };
      this.history.push(addFieldToHistory);
      this.elements.push(numberElement);
      this.getFieldsFromElements();
    },
    addSignature() {
      if (this.recipientSelection) {
        if (
          this.getAuthenticatedUser?.signature === null ||
          this.getUserSignature === null
        ) {
          this.$message.error(
            "Please add a signature in the 'My Signature' field or update the signature in the profile settings."
          );
          return;
        }
        let indx = this.getLastIndexOfElement("SIGNATURE");
        indx = indx + 1;
        var fieldHeight = 46;
        var fieldWidth = 225;
        let sizeOfLast = this.getLastElementOfType("SIGNATURE");
        if (sizeOfLast !== null) {
          fieldWidth = sizeOfLast.width;
          fieldHeight = sizeOfLast.height;
        }
        const x =
          this.mouseX +
          this.$refs.formBuilder.scrollLeft -
          this.$refs.formBuilder.getBoundingClientRect().x -
          this.deltaX;
        const y =
          this.mouseY +
          this.$refs.formBuilder.scrollTop -
          this.$refs.formBuilder.getBoundingClientRect().y -
          this.deltaY +
          this.dragItemHeight -
          fieldHeight;
        let signatureMetaData = {
          type: "SIGNATURE",
          section: "input",
          style: "background:#cbe2d8;",
          label: "Signature",
          placeholder: "Signature " + indx,
          field_type: "CUSTOM_FIELD",
          required: true,
          index: indx,
          filled_by: this.recipientSelection || "SENDER_OR_RECEIVER",
          is_entity_variable: false,
          global_variable_entity_field: "",
          files: [],
          sample_files: [],
          list_data: [],
          list_data_selected_value_ref: "",
          requiredFiles: 1,
          file_names: [],
          options: [],
          font: {
            name: "Helvetica",
            size: 16,
            style: 0,
            color: "#000000",
          },
        };
        let positionSize = {
          x:
            this.mouseX +
            this.$refs.formBuilder.scrollLeft -
            this.$refs.formBuilder.getBoundingClientRect().x -
            this.deltaX,
          y:
            this.mouseY +
            this.$refs.formBuilder.scrollTop -
            this.$refs.formBuilder.getBoundingClientRect().y -
            this.deltaY +
            this.dragItemHeight -
            fieldHeight,
          height: fieldHeight,
          width: fieldWidth,
        };
        let signatureElement = {
          ...signatureMetaData,
          ...positionSize,
        };

        // if (x > this.pageWidth - this.deltaXOfPageWidth) {
        //   return;
        // }
        let pageBoundary = this.getPagesBoundaries(y);
        if (
          pageBoundary &&
          // pageBoundary.pageOffset &&
          pageBoundary.pageWidth &&
          (x < pageBoundary.pageOffset ||
            // x + 200 > pageBoundary.pageOffset + pageBoundary.pageWidth)
            x >= pageBoundary.pageOffset + pageBoundary.pageWidth)
        ) {
          return;
        }
        if (
          pageBoundary &&
          pageBoundary.pageWidth &&
          (x < pageBoundary.pageOffset ||
            x + fieldWidth > pageBoundary.pageOffset + pageBoundary.pageWidth)
        ) {
          signatureElement.x =
            pageBoundary.pageOffset + pageBoundary.pageWidth - fieldWidth;
        }

        // let offset = this.getElementYOffet("signatureEle");

        let addFieldToHistory = {
          data: signatureElement,
          action: "add",
          index: this.elements.length,
        };
        this.history.push(addFieldToHistory);
        this.elements.push(signatureElement);
        this.getFieldsFromElements();
      } else {
        this.$message({
          message: "Please Select a Receipent User.",
          type: "warning",
        });
      }
    },
    addInitial() {
      let indx = this.getLastIndexOfElement("INITIAL");
      indx = indx + 1;
      // let offset = this.getElementYOffet("initialEle");
      if (this.recipientSelection) {
        const x =
          this.mouseX +
          this.$refs.formBuilder.scrollLeft -
          this.$refs.formBuilder.getBoundingClientRect().x -
          this.deltaX;
        const y =
          this.mouseY +
          this.$refs.formBuilder.scrollTop -
          this.$refs.formBuilder.getBoundingClientRect().y -
          this.deltaY +
          this.dragItemHeight -
          50;

        // if (x > this.pageWidth - this.deltaXOfPageWidth) {
        //   return;
        // }
        let initialMetaData = {
          type: "INITIAL",
          section: "input",
          label: "Initial" + indx,

          field_type: "CUSTOM_FIELD",
          value: "",

          index: indx,
          text: "",
          color: "",
          required: this.recipientSelection ? true : false,
          filled_by: this.recipientSelection || "SENDER_OR_RECEIVER",
          is_entity_variable: false,
          global_variable_entity_field: "",
          files: [],
          sample_files: [],
          requiredFiles: 1,
          list_data: [],
          list_data_selected_value_ref: "",
          file_names: [],
          options: [],
          font: {
            name: "Helvetica",
            size: 16,
            style: 0,
            color: "#000000",
          },
        };
        var fieldHeight = 50;
        var fieldWidth = 100;
        let sizeOfLast = this.getLastElementOfType("INITIAL");
        if (sizeOfLast !== null) {
          fieldWidth = sizeOfLast.width;
          fieldHeight = sizeOfLast.height;
        }
        let positionSize = {
          x:
            this.mouseX +
            this.$refs.formBuilder.scrollLeft -
            this.$refs.formBuilder.getBoundingClientRect().x -
            this.deltaX,
          y:
            this.mouseY +
            this.$refs.formBuilder.scrollTop -
            this.$refs.formBuilder.getBoundingClientRect().y -
            this.deltaY +
            this.dragItemHeight -
            50,
          height: fieldHeight,
          width: fieldWidth,
        };
        let initialElement = {
          ...initialMetaData,
          ...positionSize,
        };
        let pageBoundary = this.getPagesBoundaries(y);
        if (
          pageBoundary &&
          // pageBoundary.pageOffset &&
          pageBoundary.pageWidth &&
          (x < pageBoundary.pageOffset ||
            // x + 100 > pageBoundary.pageOffset + pageBoundary.pageWidth)
            x >= pageBoundary.pageOffset + pageBoundary.pageWidth)
        ) {
          return;
        }
        if (
          pageBoundary &&
          pageBoundary.pageWidth &&
          (x < pageBoundary.pageOffset ||
            x + 100 > pageBoundary.pageOffset + pageBoundary.pageWidth)
        ) {
          initialElement.x =
            pageBoundary.pageOffset + pageBoundary.pageWidth - 100;
        }
        let addFieldToHistory = {
          data: initialElement,
          action: "add",
          index: this.elements.length,
        };
        this.history.push(addFieldToHistory);
        this.elements.push(initialElement);
        this.getFieldsFromElements();
      } else {
        this.$message({
          message: "Please Select a Receipent User.",
          type: "warning",
        });
      }
    },
    async updateWidthAndHeight() {
      if (this.activatedItem.type == "PRIMARY_FIELDS") {
        this.activatedItem.height = this.activatedItem.font.size * 1.5;
        if (this.activatedItem.content.length < 6) {
          this.activatedItem.width = this.activatedItem.font.size * 3;
        } else if (this.activatedItem.content.length < 14) {
          this.activatedItem.width = this.activatedItem.font.size * 6;
        } else {
          this.activatedItem.width = this.activatedItem.font.size * 12;
        }
      } else if (this.activatedItem.type == "PARAGRAPH") {
        let lines = this.activatedItem.content.split("\n");
        if (lines.length > 1) {
          this.activatedItem.height =
            lines.length * (this.activatedItem.font.size * 1.5);
        }
        var max = lines[0].length;
        lines.map((v) => (max = Math.max(max, v.length)));
        let result = lines.filter((v) => v.length == max);
        if (result[0].length > 11) {
          this.activatedItem.width =
            result[0].length * (this.activatedItem.font.size * 3.3);
        }
      } else if (
        this.activatedItem.type == "SINGLE_LINE_TEXT" ||
        this.activatedItem.type == "DATE" ||
        this.activatedItem.type == "SELECT" ||
        this.activatedItem.type == "NUMBER" ||
        this.activatedItem.type == "MULTI_LINE_TEXT" ||
        this.activatedItem.type == "MULTI_SELECT" ||
        this.activatedItem.type == "DATE_SIGNED" ||
        this.activatedItem.type == "CURRENCY" ||
        this.activatedItem.type == "FORMULA" ||
        this.activatedItem.type == "ENTITY" ||
        this.activatedItem.type == "REPEATABLE_PARENT"
      ) {
        if (this.activatedItem.type !== "MULTI_LINE_TEXT") {
          this.activatedItem.height = this.activatedItem.font.size * 1.5;
        }
        if (this.activatedItem.label.length < 6) {
          this.activatedItem.width = this.activatedItem.font.size * 3;
        } else if (this.activatedItem.label.length < 14) {
          this.activatedItem.width = this.activatedItem.font.size * 6;
        } else {
          this.activatedItem.width = this.activatedItem.font.size * 12;
        }
      } else if (this.activatedItem.type == "YES_OR_NO") {
        this.activatedItem.height = this.activatedItem.font.size * 1.5;
        if (this.activatedItem.font.size < 10) {
          this.activatedItem.width =
            94 + (this.activatedItem.font.size - 8) * 5;
        } else if (this.activatedItem.font.size <= 16) {
          this.activatedItem.width =
            94 + (this.activatedItem.font.size - 8) * 5;
        } else if (this.activatedItem.font.size <= 20) {
          this.activatedItem.width =
            94 + (this.activatedItem.font.size - 8) * 4;
        } else {
          this.activatedItem.width =
            94 + (this.activatedItem.font.size - 8) * 3;
        }
      }

      let x = this.activatedItem.x;
      let y = this.activatedItem.y;
      let pageBoundary = this.getPagesBoundaries(y);
      if (
        pageBoundary &&
        // pageBoundary.pageOffset &&
        pageBoundary.pageWidth &&
        (x < pageBoundary.pageOffset ||
          x + this.activatedItem.width >
          pageBoundary.pageOffset + pageBoundary.pageWidth)
      ) {
        if (this.activatedItem.width > pageBoundary.pageWidth) {
          this.activatedItem.width = pageBoundary.pageWidth - 10;
        }
        this.activatedItem.x =
          pageBoundary.pageOffset +
          pageBoundary.pageWidth -
          this.activatedItem.width;
      }
    },
    getHandleByType(type, tag = "") {
      if (tag == "address") {
        type = "address";
      }
      let defaultHandles = ["tl", "tm", "tr", "mr", "br", "bm", "bl", "ml"];
      switch (type) {
        case "ENTITY":
          return ["mr", "ml"];
        case "REPEATABLE_PARENT":
          return ["mr", "ml"];
        case "FORMULA":
          return ["mr", "ml"];
        case "SELECT":
          return ["mr", "ml"];
        case "CURRENCY":
          return ["mr", "ml"];
        case "MULTI_SELECT":
          return ["mr", "ml"];
        case "DATE":
          return ["mr", "ml"];
        case "CHECKBOX":
          return defaultHandles;
        case "SINGLE_LINE_TEXT":
          return ["mr", "ml"];
        case "YES_OR_NO":
          return ["mr", "ml"];
        case "NUMBER":
          return ["mr", "ml"];
        case "ATTACHMENT":
          return defaultHandles;
        case "address":
          return defaultHandles;
        case "PRIMARY_FIELDS":
          return ["mr", "ml"];
        default:
          return defaultHandles;
      }
    },
    getTheLastFont() {
      if (this.elements.length) {
        let font = {};
        const citrus = this.elements
          .slice()
          .reverse()
          .findIndex(
            (x) =>
              x["type"] === "PRIMARY_FIELDS" ||
              x["type"] === "PARAGRAPH" ||
              x["type"] === "SINGLE_LINE_TEXT" ||
              x["type"] === "MULTI_LINE_TEXT" ||
              x["type"] === "SELECT" ||
              x["type"] === "MULTI_SELECT" ||
              x["type"] === "NUMBER" ||
              x["type"] === "YES_OR_NO" ||
              x["type"] === "DATE" ||
              x["type"] === "DATE_SIGNED" ||
              x["type"] === "CURRENCY" ||
              x["type"] === "FORMULA"
          );
        let count = this.elements.length - 1;
        let finalIndex = citrus >= 0 ? count - citrus : citrus;
        if (finalIndex > -1) {
          let lastItem = this.elements[finalIndex];
          font.name = lastItem.font.name;
          font.size = lastItem.font.size ? lastItem.font.size : lastItem.font.font_size ? lastItem.font.font_size : 16;
          font.style = lastItem.font.style;
          font.color = lastItem.font.color;
        } else {
          return null;
        }
        return font;
      }
      return null;
    },
    // getTheLastYPosition() {
    //   if (this.elements.length) {
    //     let size = {};
    //     const citrus = this.elements
    //       .slice()
    //       .reverse()
    //       .findIndex(
    //         (x) =>
    //           x["type"] === "PRIMARY_FIELDS" ||
    //           x["type"] === "SINGLE_LINE_TEXT" ||
    //           x["type"] === "NUMBER" ||
    //           x["type"] === "CURRENCY" ||
    //           x["type"] === "FORMULA"
    //       );
    //     console.log("-=-=-=-=-=-=-=-=-=-=", citrus)
    //     let count = this.elements.length - 1;
    //     let finalIndex = citrus >= 0 ? count - citrus : citrus;
    //     if (finalIndex > -1) {
    //       let lastItem = this.elements[finalIndex];
    //       size.y = lastItem.y + 30
    //     } else {
    //       return null;
    //     }
    //     return size;
    //   }
    //   return null;
    // },
    getTheLastSize() {
      if (this.elements.length) {
        let size = {};
        const citrus = this.elements
          .slice()
          .reverse()
          .findIndex(
            (x) =>
              x["type"] === "PRIMARY_FIELDS" ||
              x["type"] === "SINGLE_LINE_TEXT" ||
              x["type"] === "NUMBER" ||
              x["type"] === "CURRENCY" ||
              x["type"] === "FORMULA" ||
              x["type"] === "SIGNATURE" ||
              x["type"] === "my-signature" ||
              x["type"] === "INITIAL" ||
              x["type"] === "MY_INITIAL" ||
              x["type"] === "DATE_SIGNED"
          );
        let count = this.elements.length - 1;
        let finalIndex = citrus >= 0 ? count - citrus : citrus;
        if (finalIndex > -1) {
          let lastItem = this.elements[finalIndex];
          size.width = lastItem.width;
          size.height = lastItem.height;
        } else {
          return null;
        }
        return size;
      }
      return null;
    },
    getTheLastXYPositions() {
      if (this.elements.length) {
        let size = {};
        const citrus = this.elements
          .slice()
          .reverse()
          .findIndex(
            (x) =>
              x["type"] === "PRIMARY_FIELDS" ||
              x["type"] === "SINGLE_LINE_TEXT" ||
              x["type"] === "NUMBER" ||
              x["type"] === "CURRENCY" ||
              x["type"] === "FORMULA"
          );
        let count = this.elements.length - 1;
        let finalIndex = citrus >= 0 ? count - citrus : citrus;
        if (finalIndex > -1) {
          let lastItem = this.elements[finalIndex];
          size.y = lastItem.y;
          size.x = lastItem.x;
        } else {
          return null;
        }
        return size;
      }
      return null;
    },
  },
};
